// Isolated V2 document checklist.
import React, { useState, useEffect, useLayoutEffect, useRef, useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import '../App.css';
import { connect } from 'react-redux'
import { InboxOutlined, CloseOutlined, LeftOutlined, PlusOutlined, DownOutlined, CloseCircleOutlined, FileTextOutlined, SaveOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { Button, Input, Table, Modal, ConfigProvider, Select, Form, Col, Row, DatePicker, Spin, Upload, message, Popconfirm, Dropdown, Empty, Divider, Tooltip, Checkbox, Radio, AutoComplete, Typography } from 'antd';
import PreviewModal from "./PreviewModal";
import VerifyModal from "./VerifyModalV2";
import AutoReminderModal from "./AutoReminderModal";
import "./DocumentChecklist.css"
import { applySmartVerifyUpdates } from "./applySmartVerifyV2"
import {
    assignToBorrowersLabel,
    documentNameWithSubject,
    fetchDocumentSubjects,
    subjectsFromLegacyApplication,
} from "./documentSubjects"
import * as com from '../Common.js'
import * as JSZip from "jszip";
import heic2any from 'heic2any';
import { saveAs } from 'file-saver';
import AutoProgress from './AutoProgress';
import { updateApplicationByPath, UpdateApplicationAttribute } from '../Store/actions'
import { application } from '../State';
import { set } from 'lodash';
import { tr } from 'date-fns/locale';
import { useStatsigClient } from "@statsig/react-bindings";
import {
    DOCUMENT_TEMPLATE_SUGGESTION_LIMIT,
    DocumentTemplateStarter,
    SaveDocumentTemplateModal,
    documentTemplateRowsMatch,
    getDocumentTemplateLoanContext,
    getHighestMatchingDefaultDocumentTemplate,
    sortDocumentTemplatesForLoan,
    templateItemsToTaskDocuments,
} from '../Documents/DocumentTemplateRequestTools'
import {
    DOCUMENT_TEMPLATE_STATUS,
    getDocumentTemplate,
    listDocumentTemplates,
} from '../Documents/documentTemplateApi'
import { logDocumentTemplateEvent } from '../Documents/documentTemplateAnalytics'
import { track } from 'statsig'
import { STATSIG } from 'statsig/events'
import { getLosDocumentAutotasksV2 } from './applicationV2Client'
const { Dragger } = Upload;
const { TextArea } = Input;
const { Paragraph } = Typography;
const EditableContext = React.createContext(null);
const createEmptyDocumentRequest = (values = {}) => ({
    key: Math.random().toString(36).substring(2, 10),
    name: '',
    category: undefined,
    timeRange: undefined,
    description: '',
    ...values,
})
const documentRequestHasContent = (documents) =>
    documents.some(
        ({ name, category, timeRange, description }) =>
            Boolean(name || category || timeRange || description)
    )
const mapStateToProps = (state) => {
    return {
        application: state.application,
        progress: state.progress,
        borrower: state.borrower,
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateApplicationByPath: (path, value) => {
        dispatch(updateApplicationByPath(path, value))
    },
    updateApplicationAttribute: (t, verb) => {
        dispatch(UpdateApplicationAttribute(t, verb))
    }
})
export default function Tasks(props) {
    const [form] = Form.useForm()
    const tableRef = useRef(null)
    const [modal, contextHolder] = Modal.useModal()
    const [loading, setLoading] = useState(false)
    const [saveLoading, setSaveLoading] = useState(false)
    const [tasksLoading, setTasksLoading] = useState(false)
    const [taskDocuments, setTaskDocuments] = useState([])
    const [pageWidth, setPageWidth] = useState(680)
    const [modalType, setModalType] = useState("")
    const [currentID, setCurrentID] = useState("")
    const [currentName, setCurrentName] = useState("")
    const [currentTaskName, setCurrentTaskName] = useState("")
    const [documentList, setDocumentList] = useState([])
    const [uploadBatchIDs, setUploadBatchIDs] = useState([])
    const [originalDocumentList, setOriginalDocumentList] = useState([])
    const [uncategorizedDoc, setUncategorizedDoc] = useState([])
    const [originalUncategorizedDoc, setOriginalUncategorizedDoc] = useState([])
    const [handleDocumentSelect, setHandleDocumentSelect] = useState("")
    const [handleDocumentList, setHandleDocumentList] = useState([])
    const [handleDocumentOpen, setHandleDocumentOpen] = useState(false)
    const [handleReminderOpen, setHandleReminderOpen] = useState(false)
    const [reminderModalWidth, setReminderModalWidth] = useState(568)
    const [reminderModelType, setReminderModelType] = useState("sent")
    const [handleTransitionOpen, setHandleTransitionOpen] = useState(false)
    const [showDocumentModal, setShowDocumentModal] = useState(false)
    const [editingRow, setEditingRow] = useState(-1)
    const [fileList, setFileList] = useState([])
    const [openFilter, setOpenFilter] = useState(false)
    const [categoryValue, setCategoryValue] = useState([])
    const [statusValue, setStatusValue] = useState([])
    const [borrowerValue, setBorrowerValue] = useState([])
    const [documentCount, setDocumentCount] = useState(0)
    const [verifiedCount, setVerifiedCount] = useState(0)
    const [recipientOptions, setRecipientOptions] = useState([])
    const [addType, setAddType] = useState(1)
    const [editMode, setEditMode] = useState('')
    const [uncategorizedOpen, setUncategorizedOpen] = useState(true)
    const [fieldErrors, setFieldErrors] = useState({
        name: false,
        category: false,
    })
    const [lastReminder, setLastReminder] = useState(null)
    const [showPreviewModal, setShowPreviewModal] = useState(false)
    const [showVerifyModal, setShowVerifyModal] = useState(false)
    const [showVerifyMode, setShowVerifyMode] = useState("")
    const [showAutoReminderModal, setShowAutoReminderModal] = useState(false)
    const [handleRecord, setHandleRecord] = useState(null)
    const [file, setFile] = useState("");
    const [fileData, setFileData] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [numPages, setNumPages] = useState(1);
    const [scale, setScale] = useState(1);
    const [generalValidity, setGeneralValidity] = useState(null)
    const [extractedData, setExtractedData] = useState([])
    const [mappingData, setMappingData] = useState(null)
    const [resubmissionRecord, setResubmissionRecord] = useState([])
    const [task, setTask] = useState(null);
    const [isFilters, setIsFilters] = useState(false);
    const [documentOptions, setDocumentOptions] = useState([]);
    const [documentSubjects, setDocumentSubjects] = useState(() => subjectsFromLegacyApplication(props.application))
    const documentSubjectsRef = useRef(documentSubjects)
    const [documentOptionsOriginal, setDocumentOptionsOriginal] = useState([]);
    const [previewMode, setPreviewMode] = useState("preview");
    const [handleForm, setHandleForm] = useState("");
    const [hoveringCell, setHoveringCell] = useState({ row: null, col: null })
    const [reminderSettings, setReminderSettings] = useState({
        TurnedOn: true,
        ReminderFrequency: 'every2Days',
        EndWhen: {
            WhenLoanFunded: true,
            AfterNumberOfDays: null,
            WhenDate: null
        }
    })
    const [whenLoanFunded, setWhenLoanFunded] = useState(true)
    const [showDownloadModal, setShowDownloadModal] = useState(false)
    const [downloadData, setDownloadData] = useState([])
    const [dataType, setDataType] = useState("new")
    const [controllers, setControllers] = useState({})
    const [currentConfiguration, setCurrentConfiguration] = useState(null)
    const [documentTemplates, setDocumentTemplates] = useState([])
    const [documentTemplatesLoading, setDocumentTemplatesLoading] = useState(false)
    const [documentTemplatesError, setDocumentTemplatesError] = useState('')
    const [documentTemplateRecommendationState, setDocumentTemplateRecommendationState] = useState('')
    const [appliedDocumentTemplate, setAppliedDocumentTemplate] = useState(null)
    const [appliedDocumentTemplateItems, setAppliedDocumentTemplateItems] = useState([])
    const [applyingDocumentTemplateID, setApplyingDocumentTemplateID] = useState('')
    const [showSaveDocumentTemplateModal, setShowSaveDocumentTemplateModal] = useState(false)
    const [selectedDocumentIDs, setSelectedDocumentIDs] = useState([])
    const [batchDownloadOpen, setBatchDownloadOpen] = useState(false)
    const [batchDownloadFormat, setBatchDownloadFormat] = useState('zip')
    const [batchDownloadLoading, setBatchDownloadLoading] = useState(false)
    const [batchDownloadError, setBatchDownloadError] = useState('')
    const [batchDownloadSort, setBatchDownloadSort] = useState({ key: 'uploaded', direction: 'desc' })
    const [batchSearch, setBatchSearch] = useState('')
    // Preserve the existing category-folder packaging behavior while its
    // configuration control is hidden from this page.
    const [batchGroupByCategory] = useState(true)
    const [batchDownloadPageHeight, setBatchDownloadPageHeight] = useState(null)
    const batchDownloadPageRef = useRef(null)
    const documentListRef = useRef(documentList)
    const categoryValueRef = useRef(categoryValue)
    const statusValueRef = useRef(statusValue)

    useLayoutEffect(() => {
        if (!batchDownloadOpen) return undefined

        const updateBatchDownloadHeight = () => {
            if (!batchDownloadPageRef.current) return
            const pageTop = Math.max(batchDownloadPageRef.current.getBoundingClientRect().top, 0)
            setBatchDownloadPageHeight(Math.max(window.innerHeight - pageTop, 320))
        }

        updateBatchDownloadHeight()
        window.addEventListener('resize', updateBatchDownloadHeight)
        return () => window.removeEventListener('resize', updateBatchDownloadHeight)
    }, [batchDownloadOpen])

    const borrowerValueRef = useRef(borrowerValue)
    const documentTemplateMountedRef = useRef(true)
    const history = useHistory()
    const location = useLocation()
    const { client } = useStatsigClient()
    const documentTemplateRouteRef = useRef({
        open: location.state?.openDocumentRequest,
        templateID: location.state?.documentTemplateID,
    })

    useEffect(() => () => {
        documentTemplateMountedRef.current = false
    }, [])
    const documentTemplateLoanContext = useMemo(
        () => getDocumentTemplateLoanContext(props.application),
        [props.application]
    )
    const documentTemplateRecommendationContext = useMemo(
        () => ({
            ...documentTemplateLoanContext,
            state:
                documentTemplateRecommendationState ||
                documentTemplateLoanContext.state,
        }),
        [
            documentTemplateLoanContext,
            documentTemplateRecommendationState,
        ]
    )
    const sortedDocumentTemplates = useMemo(
        () =>
            sortDocumentTemplatesForLoan(
                documentTemplates,
                documentTemplateRecommendationContext
            ),
        [documentTemplateRecommendationContext, documentTemplates]
    )
    const appliedDocumentTemplateEdited = Boolean(
        appliedDocumentTemplate &&
            !documentTemplateRowsMatch(
                taskDocuments,
                appliedDocumentTemplateItems
            )
    )
    const logTemplateSuggestions = useCallback(
        (templates, context = documentTemplateRecommendationContext) => {
            sortDocumentTemplatesForLoan(
                templates,
                context
            )
                .slice(0, DOCUMENT_TEMPLATE_SUGGESTION_LIMIT)
                .forEach((template, index) => {
                    logDocumentTemplateEvent(client, 'template_suggested', {
                        template,
                        source: 'add_document_request',
                        metadata: {
                            rank: index + 1,
                            context_loan_type: context.loanType,
                            context_purpose: context.purpose,
                            context_income_type: context.incomeTypes.join(','),
                            context_state: context.state,
                        },
                    })
                })
        },
        [client, documentTemplateRecommendationContext]
    )

    useEffect(() => {
        const { open, templateID } = documentTemplateRouteRef.current
        if (!open || !templateID) return undefined

        documentTemplateRouteRef.current = { open: false, templateID: '' }
        let active = true
        history.replace({
            pathname: location.pathname,
            search: location.search,
        })
        setHandleDocumentSelect('add')
        setEditMode('')
        setAddType(1)
        setDocumentTemplateRecommendationState('')
        setShowDocumentModal(true)
        form.setFieldsValue({
            recipient: 'borrower',
            deadline: dayjs().add(5, 'day'),
        })

        setDocumentTemplatesLoading(true)
        setApplyingDocumentTemplateID(templateID)
        listDocumentTemplates({
            status: DOCUMENT_TEMPLATE_STATUS.ACTIVE,
        })
            .then((templates) => {
                if (active) {
                    setDocumentTemplates(templates)
                    logTemplateSuggestions(templates)
                }
            })
            .catch((requestError) => {
                if (active) {
                    setDocumentTemplatesError(
                        requestError.message || 'Unable to load templates.'
                    )
                }
            })
            .finally(() => {
                if (active) setDocumentTemplatesLoading(false)
            })

        getDocumentTemplate(templateID)
            .then((templateDetail) => {
                if (!active) return
                const templateItems = templateDetail.items || []
                setTaskDocuments(templateItemsToTaskDocuments(templateItems))
                setAppliedDocumentTemplate(templateDetail)
                setAppliedDocumentTemplateItems(
                    templateItems.map((item) => ({ ...item }))
                )
                setEditingRow(-1)
                setFieldErrors({ name: false, category: false })
                logDocumentTemplateEvent(client, 'template_applied', {
                    template: templateDetail,
                    source: 'template_library',
                })
                track(STATSIG.LOAN.DOCUMENT_TEMPLATE, {
                    type: 'applied',
                    source: 'template_library',
                })
            })
            .catch((requestError) => {
                if (active) {
                    message.error(
                        requestError.message || 'Unable to apply the template.'
                    )
                }
            })
            .finally(() => {
                if (active) setApplyingDocumentTemplateID('')
            })

        return () => {
            active = false
        }
    }, [
        client,
        form,
        history,
        location.pathname,
        location.search,
        logTemplateSuggestions,
    ])

    //statsig related
    const startVerifyTime = useRef(0)
    const handleExpand = (type) => {
        const updatedList = documentList.map(item => {
            if (item.type === type) {
                return { ...item, open: !item.open }
            }
            return item
        })
        setDocumentList(updatedList)
    }
    useEffect(() => {
        let cancelled = false
        const token = sessionStorage.getItem("ZeitroA")
        const loadSubjects = async () => {
            const subjects = await fetchDocumentSubjects(props.loanid, props.application, token)
            if (!cancelled) {
                setDocumentSubjects(subjects)
            }
        }
        loadSubjects()
        getTransitioncheck()
        getdocuments()
        getLoanProcessor()
        getLoanAutoReminderConfiguration()
        const interval = setInterval(() => {
            getdocuments(false)
        }, 5000)
        return () => {
            cancelled = true
            clearInterval(interval)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.loanid])

    // Resolve the upload batch carried by the LO email deep link. The endpoint
    // enforces loan access; stale links simply leave the normal checklist.
    useEffect(() => {
        const batchID = props.uploadBatch || new URLSearchParams(location.search).get('uploadBatch')
        if (!batchID) return
        const token = sessionStorage.getItem('ZeitroA')
        fetch(`/los/borrower-upload-notification/${encodeURIComponent(batchID)}`, { headers: { Authorization: 'Bearer ' + token } })
            .then(r => r.ok ? r.json() : null)
            .then(data => { if (data && Array.isArray(data.document_ids)) setUploadBatchIDs(data.document_ids.map(String)) })
            .catch(() => {})
    }, [props.uploadBatch, location.search])

    // Refresh document name options + Assign-to borrower label when subjects resolve.
    useEffect(() => {
        documentSubjectsRef.current = documentSubjects
        getDocumentOptions()
        setRecipientOptions((prev) => {
            if (!prev.length) return prev
            const label = assignToBorrowersLabel(documentSubjects, props.application)
            return prev.map((opt) => (opt.value === "borrower" ? { ...opt, label } : opt))
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentSubjects])
    useEffect(() => {
        documentListRef.current = documentList
    }, [documentList])
    useEffect(() => {
        if (tableRef.current) {
            const tableContainer = document.querySelector('.document-table .ant-table-body')
            if (tableContainer) {
                tableContainer.scrollTop = tableContainer.scrollHeight
            }
        }
    }, [taskDocuments.length])
    const getTransitioncheck = () => {
        let token = sessionStorage.getItem("ZeitroA")
        let api = '/los/transitioncheck'
        fetch(api, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
    
        }).then(
            response => {
                if (response.status !== 200) {
                    return
                }
                response.json().then(data => {
                   if (!data.DocumentsTransitionVisited) {
                        setTransitioncheck()
                   }
                })
            }
    
        ).catch((err) => {
            
        })
    }
    const setTransitioncheck = () => {
        let token = sessionStorage.getItem("ZeitroA")
        let api = '/los/transitioncheckvisited'
        fetch(api, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
    
        }).then(
            response => {
                if (response.status !== 200) {
                    return
                }
                setHandleTransitionOpen(true)
            }
    
        ).catch((err) => {
   
        })
    }
    const getLoanProcessor = () => {
        let token = sessionStorage.getItem("ZeitroA")
        fetch('/los/getloanprocessor', {
          body: JSON.stringify({ LoanID: props.loanid }),
          method: 'POST',
          headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache"
          }
        }).then(
          response => {
            if (response.status !== 200) {
              return
            }
            response.json().then(js => {
                const options = [
                    {
                        label: assignToBorrowersLabel(documentSubjectsRef.current, props.application),
                        value: 'borrower',
                    },
                    {
                        label: `${js.CurrentLO.FirstName} ${js.CurrentLO.LastName} (Loan Officer)`,
                        value: 'loanOfficer',
                    }
                ]
                if (js.CurrentLP && js.CurrentLP.ID !== '') {
                    options.push(
                        {
                            label: `${js.CurrentLP.FirstName} ${js.CurrentLP.LastName} (Processor)`,
                            value: 'loanProcessor',
                        }
                    )
                }
                setRecipientOptions(options)
            })
          }
        ).catch(function (err) {
            
        })
    }
    const documentUploadTime = (value) => {
        if (!value) return Number.NaN
        const timestamp = dayjs(value).valueOf()
        return Number.isFinite(timestamp) ? timestamp : Number.NaN
    }
    const sortDocumentsByUploaded = (documents = []) => {
        return [...(documents || [])].sort((a, b) => {
            const aTime = documentUploadTime(a.Uploaded)
            const bTime = documentUploadTime(b.Uploaded)
            const aHasTime = Number.isFinite(aTime)
            const bHasTime = Number.isFinite(bTime)

            // Files with a known upload time come first, newest first. Keep a
            // stable ID fallback for legacy rows whose upload time is missing.
            if (aHasTime && bHasTime && aTime !== bTime) return bTime - aTime
            if (aHasTime !== bHasTime) return aHasTime ? -1 : 1
            return (a.ID || 0) - (b.ID || 0)
        })
    }
    const formatDocumentUploadTime = (value) => {
        const timestamp = documentUploadTime(value)
        return Number.isFinite(timestamp) ? dayjs(value).format('MM/DD/YYYY h:mm A') : '-'
    }
    const documentByteSize = (document) => {
        const candidates = [document?.FileSize, document?.filesize, document?.Size, document?.size]
        for (const value of candidates) {
            const bytes = Number(value)
            if (Number.isFinite(bytes) && bytes > 0) return bytes
        }
        return 0
    }
    const documentExtension = (document) => {
        const filename = document?.FileName || document?.Name || ''
        const extension = filename.includes('.') ? filename.split('.').pop() : ''
        if (extension) return extension.toUpperCase().slice(0, 4)
        return (document?.MimeType || document?.Mime || '').includes('pdf') ? 'PDF' : 'FILE'
    }
    const formatDocumentSize = (value) => {
        const bytes = Number(value)
        if (!Number.isFinite(bytes) || bytes <= 0) return '—'
        const megabytes = bytes / (1024 * 1024)
        return `${megabytes >= 1 ? megabytes.toFixed(1) : (bytes / 1024).toFixed(1)} ${megabytes >= 1 ? 'MB' : 'KB'}`
    }
    const formatBatchLabel = (value, fallback = '') => {
        const label = String(value || fallback)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/[_-]+/g, ' ')
            .trim()
        return label ? `${label.charAt(0).toUpperCase()}${label.slice(1)}` : ''
    }
    const batchStatusLabel = (status) => ({
        requested: 'Requested',
        readyForReview: 'Ready for review',
        readyForReviewAI: 'Ready for review',
        verified: 'Verified',
        resubmit: 'Re-requested',
        requestDeleted: 'Request deleted',
        pendingUpload: 'Pending upload',
        uploaded: 'Uploaded',
        uncategorized: 'Uncategorized',
    }[status] || formatBatchLabel(status))
    const batchDocumentMetadata = (document) => {
        const fileCount = Number(document?.fileCount) || 1
        const pageCount = Number(
            document?.PageCount ?? document?.pageCount ?? document?.Pages ??
            document?.pages ?? document?.NumPages ?? document?.numPages
        )
        const parts = [
            formatBatchLabel(document?.category || document?.docType, 'Uncategorized'),
            `${fileCount} ${fileCount === 1 ? 'file' : 'files'}`,
        ]
        if (Number.isFinite(pageCount) && pageCount > 0) {
            parts.push(`${pageCount} ${pageCount === 1 ? 'page' : 'pages'}`)
        }
        const status = batchStatusLabel(document?.status || document?.Status || 'uploaded')
        if (status) parts.push(status)
        return parts.join(' · ')
    }
    const getDocumentsForCategory = (type) => {
        const category = originalDocumentList.find(item => item.type === type)
        return category ? category.list.flatMap(task => task.Documents || []) : []
    }
    const toggleDocumentSelection = (documentID) => {
        setSelectedDocumentIDs(prev => prev.includes(documentID)
            ? prev.filter(id => id !== documentID)
            : [...prev, documentID])
    }
    const setCategorySelection = (type, checked) => {
        const categoryIDs = getDocumentsForCategory(type).map(document => document.ID)
        setSelectedDocumentIDs(prev => {
            const withoutCategory = prev.filter(id => !categoryIDs.includes(id))
            return checked ? [...withoutCategory, ...categoryIDs] : withoutCategory
        })
    }
    const getSelectedDocumentRecords = () => {
        const documents = originalDocumentList.filter(category => category.type !== 'internalDocuments').flatMap(category => category.list.flatMap(task =>
            (task.Documents || []).map(document => ({
                ...document,
                category: category.type,
                taskName: task.TaskName,
                status: task.Status,
                fileCount: (task.Documents || []).length,
            }))
        ))
        const uncategorizedDocuments = uncategorizedDoc.map(document => ({
            ...document,
            category: document.category || document.docType || 'uncategorized',
            status: document.status || document.Status || 'uploaded',
            fileCount: 1,
        }))
        return documents.concat(uncategorizedDocuments).filter(document => selectedDocumentIDs.includes(document.ID))
    }
    const openBatchDownload = () => {
        setBatchDownloadError('')
        setBatchDownloadOpen(true)
    }
    const sanitizeDownloadPart = (value, fallback = 'document') => {
        const sanitized = String(value || '')
            .trim()
            .replace(/[\\/]+/g, '-')
            .replace(/[^\w.-]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^[-.]+|[-.]+$/g, '')
        return sanitized || fallback
    }
    const borrowerDownloadPrefix = () => {
        const borrower = props.application?.borrower || {}
        const firstName = sanitizeDownloadPart(borrower.firstname, '')
        const lastName = sanitizeDownloadPart(borrower.lastname, '')
        return [lastName, firstName].filter(Boolean).join('_') || 'Borrower'
    }
    const individualDownloadName = (fileName) => {
        const prefix = borrowerDownloadPrefix()
        const safeFileName = sanitizeDownloadPart(fileName)
        return safeFileName.toLowerCase().startsWith(`${prefix.toLowerCase()}_`)
            ? safeFileName
            : `${prefix}_${safeFileName}`
    }
    const zipDownloadName = () => `${borrowerDownloadPrefix()}_documents_${dayjs().format('YYYY-MM-DD')}.zip`
    const downloadBatchDocuments = async (formatOverride) => {
        const selectedRecords = getSelectedDocumentRecords()
        if (!selectedRecords.length || batchDownloadLoading) return
        if (selectedRecords.length > 50) {
            setBatchDownloadError('You can download up to 50 files at a time.')
            return
        }
        setBatchDownloadLoading(true)
        try {
            const token = sessionStorage.getItem('ZeitroA')
            // Ant Design passes the click event to handlers. Only treat an
            // explicit, supported string as an override; otherwise use the
            // format selected in the package panel.
            const downloadFormat = formatOverride === 'individual' || formatOverride === 'zip'
                ? formatOverride
                : batchDownloadFormat
            if (downloadFormat === 'individual') {
                for (const record of selectedRecords) {
                    const response = await fetch('/los/downloaddocuments', {
                        method: 'POST',
                        body: JSON.stringify({ LoanID: props.loanid, TaskID: 0, DocID: record.ID }),
                        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                    })
                    if (!response.ok) throw new Error('Unable to download documents')
                    const body = await response.json()
                    const file = body.Documents?.[0]
                    if (file?.Content) {
                        saveAs(new Blob([base64ToArrayBuffer(file.Content)], { type: file.Mime || 'application/octet-stream' }), individualDownloadName(file.Name || record.FileName))
                    }
                }
            } else {
                const archiveFilename = zipDownloadName()
                const response = await fetch('/los/batchdownloaddocuments', {
                    method: 'POST',
                    body: JSON.stringify({
                        LoanID: props.loanid,
                        DocumentIDs: selectedRecords.map(record => record.ID),
                        Format: 'zip',
                        GroupByCategory: batchGroupByCategory,
                        FilenamePrefix: borrowerDownloadPrefix(),
                        ArchiveFilename: archiveFilename,
                    }),
                    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                })
                if (!response.ok) {
                    const errorText = await response.text()
                    throw new Error(errorText || 'Unable to download documents')
                }
                const blob = await response.blob()
                saveAs(blob, archiveFilename)
            }
            message.success('Documents downloaded successfully')
        } catch (error) {
            message.error(error.message || 'Unable to download documents')
        } finally {
            setBatchDownloadLoading(false)
        }
    }
    const handleDownloadAction = () => {
        const selectedRecords = getSelectedDocumentRecords()
        if (selectedRecords.length === 1) {
            // A single selected file is already an individual download; skip
            // the workspace and start it directly from the Documents page.
            downloadBatchDocuments('individual')
            return
        }
        openBatchDownload()
    }
    const renderBatchDownloadPage = () => {
        const allRecords = getSelectedDocumentRecords()
        const queuedSize = allRecords.reduce((total, document) => total + documentByteSize(document), 0)
        const allDocuments = originalDocumentList.filter(category => category.type !== 'internalDocuments').flatMap(category => category.list.flatMap(task =>
            (task.Documents || []).map(document => ({
                ...document,
                category: category.type,
                taskName: task.TaskName,
                status: task.Status,
                fileCount: (task.Documents || []).length,
            }))
        )).concat(uncategorizedDoc.map(document => ({
            ...document,
            category: document.category || document.docType || 'uncategorized',
            status: document.status || document.Status || 'uploaded',
            fileCount: 1,
        })))
        const compareBatchDocuments = (a, b) => {
            let result = 0
            if (batchDownloadSort.key === 'document') {
                result = String(a.FileName || a.Name || '').localeCompare(String(b.FileName || b.Name || ''), undefined, { sensitivity: 'base' })
            } else if (batchDownloadSort.key === 'size') {
                result = documentByteSize(a) - documentByteSize(b)
            } else {
                const aTime = documentUploadTime(a.Uploaded)
                const bTime = documentUploadTime(b.Uploaded)
                const aValid = Number.isFinite(aTime)
                const bValid = Number.isFinite(bTime)
                if (aValid && bValid) result = aTime - bTime
                else if (aValid !== bValid) result = aValid ? -1 : 1
            }
            if (result === 0) return (a.ID || 0) - (b.ID || 0)
            return batchDownloadSort.direction === 'asc' ? result : -result
        }
        const availableDocuments = allDocuments
            .filter(document => document.FileName || document.Name)
            .sort(compareBatchDocuments)
        const query = batchSearch.trim().toLowerCase()
        const visibleDocuments = availableDocuments.filter(document => {
            const name = document.FileName || document.Name || ''
            return !query || name.toLowerCase().includes(query)
        })
        const toggleVisible = (checked) => {
            const visibleIDs = visibleDocuments.map(document => document.ID)
            setSelectedDocumentIDs(prev => {
                const withoutVisible = prev.filter(id => !visibleIDs.includes(id))
                return checked ? [...withoutVisible, ...visibleIDs] : withoutVisible
            })
        }
        const allVisibleSelected = visibleDocuments.length > 0 && visibleDocuments.every(document => selectedDocumentIDs.includes(document.ID))
        const toggleBatchSort = (key) => {
            setBatchDownloadSort(prev => prev.key === key
                ? { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' }
                : { key, direction: key === 'uploaded' ? 'desc' : 'asc' })
        }
        const batchSortIndicator = (key) => batchDownloadSort.key === key
            ? (batchDownloadSort.direction === 'asc' ? '↑' : '↓')
            : '↕'
        return (
            <div
                ref={batchDownloadPageRef}
                className="batch-download-page"
                style={batchDownloadPageHeight ? { height: `${batchDownloadPageHeight}px` } : undefined}
            >
                <div className="batch-download-page-header">
                    <Button type="text" className="batch-download-back" onClick={() => setBatchDownloadOpen(false)}>‹&nbsp; Documents</Button>
                    <div>
                        <div className="batch-download-page-title">Batch download</div>
                        <div className="batch-download-page-subtitle">{props.application.borrower.firstname} {props.application.borrower.lastname} · {availableDocuments.length} of {allDocuments.length} documents available</div>
                    </div>
                    <Input.Search className="batch-download-header-search" value={batchSearch} onChange={event => setBatchSearch(event.target.value)} placeholder="Search documents or files" allowClear />
                </div>
                <div className="batch-download-page-body">
                    <main className="batch-download-file-panel">
                        <div className="batch-download-toolbar" />
                        <div className="batch-download-file-table">
                            <div className="batch-download-file-table-head">
                                <Checkbox checked={allVisibleSelected} indeterminate={!allVisibleSelected && visibleDocuments.some(document => selectedDocumentIDs.includes(document.ID))} onChange={event => toggleVisible(event.target.checked)} />
                                <button type="button" className="batch-download-sort-button" onClick={() => toggleBatchSort('document')}>DOCUMENT <span>{batchSortIndicator('document')}</span></button>
                                <button type="button" className="batch-download-sort-button" onClick={() => toggleBatchSort('uploaded')}>UPLOADED <span>{batchSortIndicator('uploaded')}</span></button>
                                <button type="button" className="batch-download-sort-button batch-download-sort-size" onClick={() => toggleBatchSort('size')}>SIZE <span>{batchSortIndicator('size')}</span></button>
                            </div>
                            <div className="batch-download-file-content">
                                {visibleDocuments.map(document => {
                                    const id = document.ID
                                    const name = document.FileName || document.Name
                                    return (
                                        <div className={`batch-download-file-row ${selectedDocumentIDs.includes(id) ? 'selected' : ''}`} key={id}>
                                            <Checkbox checked={selectedDocumentIDs.includes(id)} onChange={() => toggleDocumentSelection(id)} />
                                            <div className="batch-download-file-name"><span title={name}>{name}</span><small>{batchDocumentMetadata(document)}</small></div>
                                            <span>{formatDocumentUploadTime(document.Uploaded)}</span>
                                            <span>{formatDocumentSize(documentByteSize(document))}</span>
                                        </div>
                                    )
                                })}
                                {!visibleDocuments.length && <Empty description="No documents found" />}
                            </div>
                        </div>
                    </main>
                    <aside className="batch-download-queue-panel">
                        <div className="batch-download-queue-heading"><span>Download queue</span><Button type="link" onClick={() => setSelectedDocumentIDs([])}>Remove all</Button></div>
                        <div className="batch-download-queue-scroll">
                            <div className="batch-download-queue-list">
                                {allRecords.map(record => <div className="batch-download-queue-card" key={record.ID}><span className="batch-download-queue-icon">{documentExtension(record)}</span><div><span>{record.FileName || record.Name}</span><small>{formatBatchLabel(record.category || record.docType, 'Uncategorized')} · {formatDocumentSize(documentByteSize(record))}{record.Uploaded ? ` · ${dayjs(record.Uploaded).format('MM/DD/YYYY')}` : ''}</small></div><Button type="text" onClick={() => toggleDocumentSelection(record.ID)}>×</Button></div>)}
                                {!allRecords.length && <div className="batch-download-queue-empty">Check documents on the left to build a batch.</div>}
                            </div>
                            <div className="batch-download-package">
                                <div className="batch-download-section-label">PACKAGE</div>
                                <Radio.Group value={batchDownloadFormat} onChange={event => setBatchDownloadFormat(event.target.value)}>
                                    <Radio value="zip">Single ZIP archive<br /><small>One file, {batchGroupByCategory ? 'folders by category.' : 'files at the root.'}</small></Radio>
                                    <Radio value="individual">Individual files<br /><small>Each document downloads separately.</small></Radio>
                                </Radio.Group>
                            </div>
                        </div>
                        <div className="batch-download-queue-footer">
                            <div><strong>{allRecords.length} document{allRecords.length === 1 ? '' : 's'} queued</strong><span>{queuedSize > 0 ? formatDocumentSize(queuedSize) : '0.0 MB'} total</span></div>
                            <Button type="primary" block loading={batchDownloadLoading} disabled={!allRecords.length} onClick={() => downloadBatchDocuments()}>Download {allRecords.length ? `${allRecords.length} document${allRecords.length === 1 ? '' : 's'}` : ''}</Button>
                            <div className="batch-download-queue-footer-hint">
                                {allRecords.length ? (batchDownloadFormat === 'zip' ? 'Single ZIP archive' : 'Individual files') : 'Nothing queued yet'}
                            </div>
                            {batchDownloadError && <div className="batch-download-error">{batchDownloadError}</div>}
                        </div>
                    </aside>
                </div>
            </div>
        )
    }
    const transformData = (data) => {
        const transformed = {}
        categoryOptions.forEach(category => {
            const existingItem = documentListRef.current.find(item => item.type === category.value)
            const openState = existingItem ? existingItem.open : true
    
            transformed[category.value] = {
                type: category.value,
                open: openState,
                list: []
            }
        })
        data.forEach(item => {
            const { TaskID } = item

            if (transformed[TaskID]) {
                transformed[TaskID].list.push(item)
                // transformed[TaskID].list.push({...item, LatestNoticeTime: "2024-07-19 15:44:59.277902 +0800 CST"})
            }
        })
        Object.values(transformed).forEach(category => {
            category.list.sort((a, b) => a.ID - b.ID)
        })
        return Object.values(transformed)
    }
    const getdocuments = (showLoading = true) => {
        let token = sessionStorage.getItem("ZeitroA")
        if (showLoading) {
            setTasksLoading(true)
        }
        let api = '/los/getdocuments/'+ props.loanid
        fetch(api, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
    
        }).then(
            response => {
                if (showLoading) {
                    setTasksLoading(false)
                }
                if (response.status !== 200) {
                    return
                }
                response.json().then(data => {
                    // Normalize file order once so every V2 category, including
                    // Miscellaneous/Uncategorized, shows the newest upload first.
                    const originalData = data.map(task => ({
                        ...task,
                        Documents: sortDocumentsByUploaded(task.Documents),
                    }))
                    const uncategorizedList = originalData.filter(task => task.TaskID === 'uncategorized')
                    .flatMap(task => 
                        task.Documents.map(document => ({
                            ...document,
                            requestId: task.ID,
                            Updated: task.Updated,
                            docType: task.TaskID,
                            ExtraInfo: document.ExtraInfo ? JSON.parse(document.ExtraInfo) : {}
                        }))
                    )
                    const list = transformData(originalData)
                    let total = 0
                    let verified = 0
                    list.forEach((item) => {
                        total += item.list.length
                        verified += item.list.filter(task => task.Status === 'verified').length
                    })
                    setDocumentCount(total + uncategorizedList.length)
                    setVerifiedCount(verified)
                    setOriginalDocumentList(list)
                    setUncategorizedDoc(uncategorizedList)
                    setOriginalUncategorizedDoc(uncategorizedList)
                    if (categoryValueRef.current.length > 0 || statusValueRef.current.length > 0 || borrowerValueRef.current.length > 0) {
                        setIsFilters(true)
                        const filteredDocumentList = list.map(item => {
                            if (categoryValueRef.current.length > 0 && !categoryValueRef.current.includes(item.type)) {
                                return { ...item, list: [] }
                            }
                            const filteredList = item.list.filter(doc => {
                                if (statusValueRef.current.length > 0) {
                                    if (statusValueRef.current.includes('readyForReview')) {
                                        if (!['readyForReviewAI', 'readyForReview'].includes(doc.Status)) {
                                            return false
                                        }
                                    } else if (!statusValueRef.current.includes(doc.Status)) {
                                        return false
                                    }
                                }
                                if (borrowerValueRef.current.length > 0) {
                                    const taskNameParts = doc.TaskName.split('-')
                                    const lastPart = taskNameParts[taskNameParts.length - 1].trim()
            
                                    if (!borrowerValueRef.current.includes(lastPart) && taskNameParts.length > 1) {
                                        return false
                                    }
                                }
                                return true
                            })
                            return { ...item, list: filteredList }
                        })
                        setDocumentList(filteredDocumentList)
                    } else {
                        setDocumentList(list)
                        setIsFilters(false)
                    }
                    if (handleForm === 'verify') {
                        let doc = originalData.filter(item => item.ID === task.ID)[0]
                        if (doc.Documents.length > 0) {
                            handleReview(doc, doc.Documents[0], 0, 'verify', true, true)
                        } else {
                            setShowPreviewModal(false)
                        }
                    }
                })
            }
    
        ).catch((err) => {
            if (showLoading) {
                setTasksLoading(false)
            }
        })
    }
    const deleteDocFile = (record) => {
        setCurrentID(record.ID)
        setCurrentName(record.FileName)
        setModalType('deleteFile')
        setHandleDocumentOpen(true)
    }
    const previewDoc = (data, record, index, type, isVerify) => {
        setTask(data)
        setPreviewMode(type)
        setHandleRecord({...record, taskName: data.TaskName, forWhom: data.ForWhom, num: index + 1, documents: data.Documents, total: data.Documents.length, description: data.Description, duedate: data.Deadline, timeRange: getLabelByValue(timeRangeOptions, data.TimeRange), docType: data.TaskID})
        downloadAll(data.ID, 'preview', record.FileName, record.ID, isVerify)
    }
    const handleReview = (data, record, index, type, isVerify, isReview) => {
        setTask(data)
        setPreviewMode(type)
        setHandleRecord({...record, taskName: data.TaskName, forWhom: data.ForWhom, num: index + 1, documents: data.Documents, total: data.Documents.length, description: data.Description, duedate: data.Deadline, timeRange: getLabelByValue(timeRangeOptions, data.TimeRange), docType: data.TaskID})
        downloadAll(data.ID, 'preview', record.FileName, null, isVerify, isReview)
    }
    const moveDoc = (data, record, index, type) => {
        setTask(data)
        setPreviewMode(type)
        setHandleRecord({...record, taskName: data.TaskName, docType: data.TaskID, taskId: data.ID })
        downloadAll(data.ID, type, record.FileName, record.ID)
    }
    const moveUncategorized = (record, type) => {
        setPreviewMode(type)
        setHandleRecord({...record})
        downloadAll(record.requestId, type, record.FileName, record.ID)
    }
    const toSettings = () => {
        history.push({
            pathname: '/app/creditpullsetting',
            state: { selected: 'feature' }
        })
    }
    const documentReminderCancel = () => {
        setHandleReminderOpen(false)
    }
    const showCurrentTasks  = () => {  
        const formatStatus = {
            requested : {
                label: 'Requested',
                tooltip: ''
            },
            readyForReview : {
                label: 'Ready for review',
                tooltip: 'The document has been uploaded and scanned by AI. Extracted data is ready for verification.'
            },
            // readyForReview : {
            //     label: 'Ready for review',
            //     tooltip: 'The document has been uploaded, but at least one file is not AI-readable. Manual verification is needed.'
            // },
            verified : {
                label: 'Verified',
                tooltip: ''
            },
            resubmit : {
                label: 'Re-requested',
                tooltip: ''
            },
            uncategorized: {
                label: 'Uncategorized',
                tooltip: ''
            },
            requestDeleted : {
                label: 'Request deleted',
                tooltip: ''
            },
            pendingUpload : {
                label: 'Pending upload',
                tooltip: ''
            },
            uploaded : {
                label: 'Uploaded',
                tooltip:'The document has been uploaded but is still being processed by AI and is not yet ready for review. This may take a few minutes.'
            }
        }
        const mapStatusTagStyle = (status) => {
            switch (status) {
                case 'readyForReviewAI':
                  return { color: '#6730CE', backgroundColor: '#D8EAFF', border: '2px solid #13358D' }
                case 'readyForReview':
                  return { color: '#13358D', backgroundColor: '#D8EAFF', border: '2px solid #13358D' }
                case 'verified':
                  return { color: '#2E605A', backgroundColor: '#E1F2E2' }
                case 'requestDeleted':
                  return { color: '#979797', backgroundColor: '#FFFFFF' }
                case 'pendingUpload':
                case 'uncategorized':
                  return { color: '#9C7000', backgroundColor: '#FFE6A6' }
                case "uploaded":
                  return { color: '#13358D', backgroundColor: '#D8EAFF' }
                default:
                  return { color: '#222', backgroundColor: '#E0E0E0' }
            }
        }
        const mapViewStyle = (status) => {
            switch (status) {
                case 'readyForReviewAI':
                case 'readyForReview':
                case 'verified':
                case 'uncategorized':
                    return { color: '#FFFFFF', backgroundColor: '#325CEB' };
                case 'resubmit':
                    return { color: '#325CEB', backgroundColor: '#FCFCFC', border: '1px solid #325CEB' };
                default:
                    return { color: '#979797', backgroundColor: '#FCFCFC', border: '1px solid #ECECEC', cursor: 'no-drop' };
            }
        }
        const dropdownMenu = (record) => {
            const dropdownItems = [
                {
                    label: 'Upload document',
                    key: 'upload',
                    icon: <img src='/images/document-upload-grey.svg' />,
                },
                {
                    type: 'divider',
                },
                {
                    label: <span style={record.Documents.length === 0 ? { color: 'rgba(84, 84, 89, 0.22)' } : {}}>Download document</span>,
                    key: 'download',
                    icon: <img src={`/images/document-download-${record.Documents.length === 0 ? 'disabled' : 'grey'}.svg`} />,
                    disabled: record.Documents.length === 0,
                },
                {
                    type: 'divider',
                },
            ]
        
            if (record.Status === 'requested') { 
                dropdownItems.push(
                    {
                        label: 'Send reminder',
                        key: 'sendReminder',
                        icon: <div style={{width: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center'}}><img src='/images/document-remind-grey.svg' /></div>,
                    },
                    {
                        type: 'divider',
                    }
                )
            }
        
            dropdownItems.push(
                {
                    label: <span style={record.Documents.length === 0 ? { color: 'rgba(84, 84, 89, 0.22)' } : {}}>Request resubmission</span>,
                    key: 'resubmission',
                    icon: <img src={`/images/document-resubmission-${record.Documents.length === 0 ? 'disabled' : 'grey'}.svg`} />,
                    disabled: record.Documents.length === 0,
                },
                {
                    type: 'divider',
                },
                {
                    label: <span style={record.Documents.length > 0 ? { color: 'rgba(84, 84, 89, 0.22)' } : {}}>Edit request</span>,
                    key: 'edit',
                    icon: <img src={`/images/document-edit-${record.Documents.length > 0 ? 'disabled' : 'grey'}.svg`} />,
                    disabled: record.Documents.length > 0,
                },
                {
                    type: 'divider',
                },
                {
                    label: 'Delete request',
                    key: 'delete',
                    icon: <img src='/images/document-delete-grey.svg' />,
                }
            )
        
            return dropdownItems
        }
        const handleDocument = (e, record) => {
            setCurrentID(record.ID)
            if (e.key === 'delete') {
                setModalType('deleteDoc')
                setHandleDocumentOpen(true)
            } else if (e.key === 'download') {
                downloadAll(record.ID, 'single', record.TaskName)
            } else if (e.key === 'upload') {
                setHandleDocumentSelect('upload')
                setEditMode('upload')
                form.setFieldsValue({
                    name: record.TaskName,
                    category: record.TaskID,
                    description: record.Description
                })
                setShowDocumentModal(true)
            } else if (e.key === 'resubmission') {
                setHandleDocumentList(record.Documents)
                setHandleDocumentSelect('resubmission')
                setEditMode('resubmission')
                form.setFieldsValue({
                    name: record.TaskName,
                    category: record.TaskID,
                })
                setShowDocumentModal(true)
            } else if (e.key === 'edit') {
                setHandleDocumentSelect('add')
                setEditMode('add')
                setAddType(record.ForWhom === 'borrower' ? 1 : 2)
                form.setFieldsValue({
                    recipient: record.ForWhom,
                    name: record.TaskName,
                    category: record.TaskID,
                    timerange: record.TimeRange === '' ? undefined : record.TimeRange,
                    deadline: dayjs(record.Deadline),
                    description: record.Description,
                    HideForBorrower: record.HideForBorrower
                })
                setShowDocumentModal(true)
            } else {
                setCurrentTaskName(record.TaskName)
                setModalType('sendReminder')
                setHandleDocumentOpen(true)
            }
        }

        const reviewDoc = (record) => {
            if (['readyForReviewAI', 'readyForReview', 'verified', 'resubmit'].includes(record.Status) && record.Documents.length > 0) {
                setCurrentID(record.ID)
                handleReview(record, record.Documents[0], 0, 'verify', true, true)
            }
            // if (record.Documents.length > 0) {
            //     setCurrentID(record.ID)
            //     handleReview(record, record.Documents[0], 0, 'verify', true, true)
            // }
        }
        const handleUncategorized = (e, record) => {
            downloadAll(0, 'single', record.FileName, record.ID)
        }
        const uncategorizedColumns = [
            {
                title: "",
                width: 48,
                render: (_, record) => (
                    <Checkbox
                        checked={selectedDocumentIDs.includes(record.ID)}
                        onChange={() => toggleDocumentSelection(record.ID)}
                        onClick={event => event.stopPropagation()}
                    />
                ),
            },
            {
                title: (
                    <div className="document-header-name">
                        <span>{'UNcategorized'.toUpperCase()}</span>
                    </div>
                ),
                render: (_, record) => {
                    const isNewUpload = uploadBatchIDs.includes(String(record.ID))
                    return (
                        <div className="borrower-upload-name">
                            <Paragraph className="document-name" ellipsis={{ rows: 1, tooltip: record.FileName }}><img style={{marginRight: 6}} src={ record?.MimeType === "application/pdf" ? '/images/pdf-icon.svg' : '/images/img-icon.svg'}/>{removeFileExtension(record.FileName)}</Paragraph>
                            {isNewUpload && <span className="borrower-upload-new-pill">NEW</span>}
                        </div>
                    )
                },
            },
            {
                title: <span style={{ color: '#545459', fontWeight: 500 }}>Status</span>,
                dataIndex: 'ExtraInfo',
                key: 'ExtraInfo',
                width: 200,
                sorter: (a, b) => a.ExtraInfo.status.localeCompare(b.ExtraInfo.status),
                render: (_, record) => {
                    const { status } = record.ExtraInfo;
                    return status === 'processing' ? (
                        <div className='doc-processing'>
                            <AutoProgress 
                                type="circle"
                                showInfo={false}
                                percent="auto"
                                strokeWidth={14} 
                                trailColor="#E3EAFD" 
                                strokeColor="#325CEB"
                                size={24}
                            />
                            <span className='processing-text'>Processing</span>
                        </div>
                    ) : (
                        <div style={mapStatusTagStyle(status)} className='document-status'>
                            <span>{formatStatus[status]?.label}</span>
                        </div>
                    );
                },
            },
            {
                title: <span style={{ color: '#545459', fontWeight: 500 }}>Uploaded</span>,
                dataIndex: 'Uploaded',
                key: 'Uploaded',
                width: 180,
                sorter: (a, b) => documentUploadTime(b.Uploaded) - documentUploadTime(a.Uploaded),
                render: (text) => (
                    <Tooltip arrow={false} placement="top" title={text ? dayjs(text).format('MM/DD/YYYY h:mm:ss A') : 'Upload time unavailable'}>
                        <span style={{ color: '#545459', whiteSpace: 'nowrap' }}>
                            {text ? `Uploaded ${formatDocumentUploadTime(text)}` : '-'}
                        </span>
                    </Tooltip>
                ),
            },
            {
                title: (
                    <div className='collapse-header-arrow uncategorized-wrap'>
                        <img style={{ cursor: 'pointer' }} className={uncategorizedOpen ? 'up' : 'down'} onClick={() => setUncategorizedOpen(!uncategorizedOpen)} src='/images/document-collapse.svg' />
                    </div>
                ),
                dataIndex: '',
                key: '',
                width: 156,
                render: (_, record, index) => (
                    <div className='document-action-wrap'>
                        <div style={mapViewStyle(record.docType)} className='document-view' onClick={() => moveUncategorized(record, 'sort')}>View</div>
                        <Dropdown
                            overlayClassName="document-checklist-dropdown"
                            menu={{
                                items: [
                                    {
                                        label: 'Download',
                                        key: 'download',
                                    }
                                ],
                                onClick: (e) => handleUncategorized(e, record)
                            }}
                            placement="bottomRight"
                            trigger={['click']}
                        >
                            <div className='document-more'><img src='/images/document-more.svg' /></div>
                        </Dropdown>
                    </div>
                ),
            },
        ]
        const previewFile = (record) => {
            if (record.Documents.length > 0) {
                previewDoc(record, record.Documents[0], 0, 'preview')
            }
        }
        const columnsData = (type) => {
            const categoryDocuments = getDocumentsForCategory(type)
            const categoryIDs = categoryDocuments.map(document => document.ID)
            const selectedCategoryCount = categoryIDs.filter(id => selectedDocumentIDs.includes(id)).length
            const documentColumns = [
                {
                    title: (
                        <div className="document-header-name">
                            <Checkbox
                                checked={categoryDocuments.length > 0 && selectedCategoryCount === categoryDocuments.length}
                                indeterminate={selectedCategoryCount > 0 && selectedCategoryCount < categoryDocuments.length}
                                onChange={event => setCategorySelection(type, event.target.checked)}
                                onClick={event => event.stopPropagation()}
                            />
                            <span>{type.toUpperCase()}</span>
                            {type === 'internalDocuments' && (
                                <Tooltip arrow={false} placement="bottomLeft" title='Internal documents are hidden from borrowers'>
                                    <img style={{marginLeft: '14px'}} src='/images/hidden-icon.svg'/>
                                </Tooltip>
                            )}
                        </div>
                    ),
                    render: (_, record) => {
                        const recordDocuments = record.Documents || []
                        const recordIDs = recordDocuments.map(document => document.ID)
                        const selectedRecordCount = recordIDs.filter(id => selectedDocumentIDs.includes(id)).length
                        const hasNewUpload = recordDocuments.some(document => uploadBatchIDs.includes(String(document.ID)))
                        return (
                        <div className="document-name-wrap">
                            <Checkbox
                                checked={recordIDs.length > 0 && selectedRecordCount === recordIDs.length}
                                indeterminate={selectedRecordCount > 0 && selectedRecordCount < recordIDs.length}
                                disabled={recordIDs.length === 0}
                                onChange={event => {
                                    const checked = event.target.checked
                                    setSelectedDocumentIDs(prev => {
                                        const withoutRecord = prev.filter(id => !recordIDs.includes(id))
                                        return checked ? [...withoutRecord, ...recordIDs] : withoutRecord
                                    })
                                }}
                                onClick={event => event.stopPropagation()}
                            />
                            <span className="borrower-upload-name">
                                <Paragraph className="document-name" ellipsis={{ rows: 2, tooltip: record.TaskName }} onClick={() => previewFile(record)}>{record.TaskName}</Paragraph>
                                {hasNewUpload && <span className="borrower-upload-new-pill">NEW</span>}
                            </span>
                        </div>
                        )
                    },
                },
                {
                    title: <span style={{color: '#545459', fontWeight: 500}}>Status</span>,
                    dataIndex: 'Status',
                    key: 'Status',
                    width: 200,
                    sorter: (a, b) => a.Status.localeCompare(b.Status),
                    render: (_, record, index) => (
                        <Tooltip arrow={false} placement="bottomLeft" title={formatStatus[record.Status]?.tooltip || ''}>
                            <div style={mapStatusTagStyle(record.Status)} className='document-status'><span>{formatStatus[record.Status]?.label || record.Status}</span>{record.Status === 'readyForReview' && <img src='/images/document-sparkles.svg'/>}</div>
                        </Tooltip>
                    ),
                },
                {
                    title: <span style={{color: '#545459', fontWeight: 500}}>Due date</span>,
                    dataIndex: 'Deadline',
                    key: 'Deadline',
                    width: 112,
                    sorter: (a, b) => new Date(a.Deadline) - new Date(b.Dead1line),
                    render: (text) => <span style={{color: '#545459'}}>{text ? dayjs(text).format('MM/DD/YYYY') : "-"}</span>,
                },
                {
                    title: <span style={{color: '#545459', fontWeight: 500}}>Last update</span>,
                    dataIndex: 'Updated',
                    key: 'Updated',
                    width: 130,
                    sorter: (a, b) => new Date(a.Updated) - new Date(b.Updated),
                    render: (text) => <span style={{color: '#545459'}}>{text ? dayjs(text).format('MM/DD/YYYY') : "-"}</span>,
                },
                {
                    title: (
                        <div className='collapse-header-arrow'>
                            <img style={{cursor: 'pointer'}} className={documentList.find(item => item.type === type).open ? 'up' : 'down'} onClick={() => handleExpand(type)} src='/images/document-collapse.svg'/>
                        </div>
                    ),
                    dataIndex: '',
                    key: '',
                    width: 156,
                    render: (_, record, index) => (
                        <div className='document-action-wrap' style={{justifyContent: 'flex-end'}}>
                            {/* <div style={record.Documents.length === 0 ? { color: '#979797', backgroundColor: '#FCFCFC', border: '1px solid #ECECEC', cursor: 'no-drop' } : mapViewStyle(record.Status)} className='document-view' onClick={() => reviewDoc(record)}>Review</div> */}
                            <div style={record.Documents.length === 0 ? { color: '#979797', backgroundColor: '#FCFCFC', border: '1px solid #ECECEC', cursor: 'no-drop' } : mapViewStyle(record.Status)} className='document-view' onClick={() => reviewDoc(record)}>Review</div>
                            <Dropdown
                                overlayClassName="document-checklist-dropdown"
                                menu={{
                                    items: dropdownMenu(record),
                                    onClick: (e) => handleDocument(e, record)
                                }}
                                placement="bottomRight"
                                trigger={['click']}
                            >
                                <div className='document-more'><img src='/images/document-more.svg'/></div>
                            </Dropdown>
                        </div>
                    ),
                },
            ]
            return documentColumns
        }

        const handleAddBtn = () => {
            setModalType('action')
            setHandleDocumentOpen(true)
        }
        const documentChecklistCancel = () => {
            setHandleDocumentOpen(false)
        }
        const turnOffReminder = () => {
            let data = {
                ...reminderSettings,
                TurnedOn: false,
                EndWhen: {
                    ...reminderSettings.EndWhen,
                    AfterNumberOfDays: null
                }
            }
            setLoanAutoReminderConfiguration(data, 'TurnedOff')
        }
        const handleSelect = (type) => {
            setHandleDocumentSelect(type)
            documentChecklistCancel()
            setDocumentTemplateRecommendationState('')
            setShowDocumentModal(true)
            if (type === 'add') {
                setTaskDocuments([createEmptyDocumentRequest()])
                setEditingRow(0)
                setFieldErrors({ name: false, category: false })
                loadActiveDocumentTemplates({ autoApplyDefault: true })
            }
            form.setFieldsValue({
                recipient: 'borrower',
                deadline: dayjs().add(5, 'day')
            })
        }
        const categoryChange = (checkedValues) => {
            setCategoryValue(checkedValues)
        }
        const statusChange = (checkedValues) => {
            setStatusValue(checkedValues)
        }
        const borrowerChange = (checkedValues) => {
            setBorrowerValue(checkedValues)
        }
        const clearAllFilter = () => {
            setCategoryValue([])
            setStatusValue([])
            setBorrowerValue([])
        }
        const applyFilter = () => {
            categoryValueRef.current = categoryValue
            statusValueRef.current = statusValue
            borrowerValueRef.current = borrowerValue
            if (categoryValue.length > 0 || statusValue.length > 0 || borrowerValue.length > 0) {
                setIsFilters(true)
            } else {
                setIsFilters(false)
            }
            const filteredDocumentList = originalDocumentList.map(item => {
                if (categoryValue.length > 0 && !categoryValue.includes(item.type)) {
                    return { ...item, list: [] }
                }
                const filteredList = item.list.filter(doc => {
                    if (statusValue.length > 0) {
                        if (statusValue.includes('readyForReview')) {
                            if (!['readyForReviewAI', 'readyForReview'].includes(doc.Status)) {
                                return false
                            }
                        } else if (!statusValue.includes(doc.Status)) {
                            return false
                        }
                    }
                    if (borrowerValue.length > 0) {
                        const taskNameParts = doc.TaskName.split('-')
                        const lastPart = taskNameParts[taskNameParts.length - 1].trim()

                        if (!borrowerValue.includes(lastPart) && taskNameParts.length > 1) {
                            return false
                        }
                    }
                    return true
                })
                return { ...item, list: filteredList }
            })
            setDocumentList(filteredDocumentList)
            closeFilter()
        }   
        const closeFilter = () => {
            setOpenFilter(false)
        }
        const filterDropdownContent = () => {
            const extraCoborrowers = documentSubjects.filter((s) => !s.isPrimary)
            // Legacy filter shows borrower column when hascoborrower; also when V2 has coborrowers.
            const showBorrowerFilter = props.application.hascoborrower === "withcoborrower" || extraCoborrowers.length > 0
            return (
                <div className='document-filter-content' style={showBorrowerFilter ? {width: '684px'}: {width: '506px'}}>
                    <div className='filter-title'>
                        <span>All filters</span>
                        <CloseOutlined className='close-filter' onClick={closeFilter} />
                    </div>
                    <Row className='filter-checkbox-wrap'>
                        <Col sm={showBorrowerFilter ? 8 : 12} span={24}>
                            <div style={{color: '#222', fontWeight: 500, marginBottom: 18}}>Category</div>
                            <Checkbox.Group
                                className='filter-checkbox-group'
                                style={{
                                    width: '100%',
                                }}
                                value={categoryValue}
                                onChange={categoryChange}
                            >
                                <Row>
                                    {
                                        categoryOptions.map((item, index) => (
                                            <Col style={{marginBottom: 8}} span={24} key={index}>
                                                <Checkbox value={item.value}><span className='filter-checkbox-label'>{item.label}</span></Checkbox>
                                            </Col>
                                        ))
                                    }
                                </Row>
                            </Checkbox.Group>
                        </Col>
                        <Col sm={showBorrowerFilter ? 8 : 12} span={24}>
                            <div style={{color: '#222', fontWeight: 500, marginBottom: 18}}>Status</div>
                            <Checkbox.Group
                                style={{
                                width: '100%',
                                }}
                                value={statusValue}
                                onChange={statusChange}
                            >
                                <Row>
                                    {
                                        statusFilterOptions.map((item, index) => (
                                            <Col style={{marginBottom: 8}} span={24} key={index}>
                                                <Checkbox value={item.value}><span className='filter-checkbox-label'>{item.label}</span></Checkbox>
                                            </Col>
                                        ))
                                    }
                                </Row>
                            </Checkbox.Group>
                        </Col>
                        {
                            showBorrowerFilter && (
                                <Col sm={8} span={24}>
                                    <div style={{color: '#222', fontWeight: 500, marginBottom: 18}}>Borrower</div>
                                    <Checkbox.Group
                                        style={{
                                        width: '100%',
                                        }}
                                        value={borrowerValue}
                                        onChange={borrowerChange}
                                    >
                                        <Row>
                                            <Col style={{marginBottom: 8}} span={24}>
                                                <Checkbox value={`${props.application.borrower.firstname} ${props.application.borrower.lastname.charAt(0)}.`}><span className='filter-checkbox-label'>{`${props.application.borrower.firstname} ${props.application.borrower.lastname}`}</span></Checkbox>
                                            </Col>
                                            {props.application.hascoborrower === "withcoborrower" && (
                                                <Col style={{marginBottom: 8}} span={24}>
                                                    <Checkbox value={`${props.application.coborrower.firstname} ${props.application.coborrower.lastname.charAt(0)}.`}><span className='filter-checkbox-label'>{`${props.application.coborrower.firstname} ${props.application.coborrower.lastname}`}</span></Checkbox>
                                                </Col>
                                            )}
                                            {extraCoborrowers
                                                .filter((s) => {
                                                    if (props.application.hascoborrower !== "withcoborrower") return true
                                                    const legacyCoSuffix = `${props.application.coborrower.firstname} ${props.application.coborrower.lastname.charAt(0)}.`
                                                    return s.suffix !== legacyCoSuffix
                                                })
                                                .map((subject) => (
                                                    <Col style={{marginBottom: 8}} span={24} key={subject.partyId || subject.suffix}>
                                                        <Checkbox value={subject.suffix}>
                                                            <span className='filter-checkbox-label'>{subject.fullName}</span>
                                                        </Checkbox>
                                                    </Col>
                                                ))}
                                        </Row>
                                    </Checkbox.Group>
                                </Col>
                            )
                        }
                    </Row>
                    <Row align="middle" className='filter-action'>
                        <Col sm={12} span={24}>
                            <span className='clear-filter' onClick={clearAllFilter}>Clear all</span>
                        </Col>
                        <Col style={{display: 'flex', flexDirection: 'row-reverse'}} sm={12} span={24}>
                            <div className='apply-filter' onClick={applyFilter}>Apply filters</div>
                        </Col>
                    </Row>
                </div>
            )
        }
        const expandedRowRender = (data) => {
            const nestedColumns = [
                {
                    title: '',
                    key: 'expand-placeholder',
                    width: 48,
                    render: () => <span aria-hidden="true" />,
                },
                {
                    title: '',
                    dataIndex: 'FileName',
                    key: 'FileName',
                    render: (_, record, index) => (
                        <div className='document-file-name-cell' style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                            <Checkbox
                                checked={selectedDocumentIDs.includes(record.ID)}
                                onChange={() => toggleDocumentSelection(record.ID)}
                                onClick={event => event.stopPropagation()}
                            />
                            <img src={`/images/${record.MimeType === 'application/pdf' ? 'pdf' : 'img'}-icon-grey.svg`} />
                            <span className="borrower-upload-name">
                                <span className='preview-filename' onClick={() => previewDoc(data, record, index, 'preview')}>{removeFileExtension(record.FileName)}</span>
                                {uploadBatchIDs.includes(String(record.ID)) && <span className="borrower-upload-new-pill">NEW</span>}
                            </span>
                        </div>
                    ),
                },
                {
                    title: '',
                    width: 200,
                    render: (_, record) => (
                        <>
                            <div>{record.ExtraInfo ===  "{}" ? '' : ''}</div>
                        </>
                    ),
                },
                {
                    title: '',
                    dataIndex: 'Uploaded',
                    key: 'Uploaded',
                    // The nested table has no Last update column, so this
                    // cell spans the Due date + Last update space.
                    width: 242,
                    render: (_, record) => (
                        <Tooltip arrow={false} placement="top" title={record.Uploaded ? dayjs(record.Uploaded).format('MM/DD/YYYY h:mm:ss A') : 'Upload time unavailable'}>
                            <span style={{ color: '#545459', whiteSpace: 'nowrap' }}>
                                {record.Uploaded ? `Uploaded ${formatDocumentUploadTime(record.Uploaded)}` : '-'}
                            </span>
                        </Tooltip>
                    ),
                },
                {
                    title: '',
                    key: 'action',
                    width: 156,
                    render: (_, record, index) => (
                        data.Status !== 'verified' && (
                            <div className='document-action-wrap'>
                                <div style={{width: '75px',display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}>
                                    <img style={{width: 20, height: 20, cursor: 'pointer'}} src='/images/document-delete.svg' onClick={() => deleteDocFile(record)} />
                                    <Tooltip overlayClassName='move-doc-tooltip' arrow={false} placement="top" title="Move this file to another document type">
                                        <img style={{width: 20, height: 20, cursor: 'pointer'}} src='/images/document-fileMove.svg' onClick={() => moveDoc(data, record, index, 'move')} />
                                    </Tooltip>
                                </div>
                            </div>
                        )
                    ),
                },
            ];
    
            return <Table
                rowKey="ID"
                className='document-file-table'
                columns={nestedColumns}
                dataSource={data.Documents}
                pagination={false}
                showHeader={false}
                rowClassName={(record) => uploadBatchIDs.includes(String(record.ID)) ? 'borrower-upload-highlight' : ''}
            />
        }
        const hasNonEmptyList = originalDocumentList.some(item => item.list.length > 0)
        const filterCount = () => {
            return categoryValue.length + statusValue.length + borrowerValue.length
        }
        const reminderConfirm = () => {
            setReminderModalWidth(500)
            setReminderModelType('reminderSuccess')
            setHandleReminderOpen(true)
            setTimeout(() => {
                if (reminderModelType === 'reminderSuccess') {
                    setHandleReminderOpen(false)
                }
            }, 4000)
        }
        const middleModelContent = () => {
            if (modalType === 'action') {
                return (
                    <>
                        <div className='btn-tips'>Create a new document request for the borrowers or processors.</div>
                        <div className='document-checklist-btn add' onClick={() => handleSelect('add')}><img src='/images/document-request.svg' />Add document request</div>
                        <Divider className='document-divider' plain>or</Divider>
                        <div className='btn-tips'>Directly upload a document that hasn't been added as a document request item.</div>
                        <div className='document-checklist-btn upload' onClick={() => handleSelect('upload')}><img src='/images/document-upload.svg' />Upload new document</div>
                    </>
                )
            } else if (modalType === 'deleteDoc') {
                return (
                    <div className='delete-wrap'>
                        <div className='delete-title'>Delete document request?</div>
                        <div className='delete-content'>Are you sure you want to delete this document request? This action cannot be undone. Any existing files uploaded for this document request will be deleted as well.</div>
                    </div>
                )
            } else if (modalType === 'deleteFile') {
                return (
                    <div className='delete-wrap'>
                        <div className='delete-title'>Delete this file?</div>
                            <div className='delete-content'>
                                <div>Are you sure you want to delete <span style={{fontWeight: 600}}>{currentName}</span>?</div>
                                <div>This action cannot be undone. </div>
                            </div>
                    </div>
                )
            } else {
                return (
                    <div className='send-reminder'>
                        <img src='/images/document-send-reminder.svg' />
                        <div style={{marginBottom: 32}}>You're about to send borrower(s) an email reminder for <span style={{fontWeight: 600}}>{currentTaskName}</span></div>
                        <div style={{marginBottom: 48}}>Would you like to include reminders for all other documents that haven't been uploaded yet?</div>
                    </div>
                )
            }
        }
        const showReminderModal = () => {
            documentReminderCancel()
            setReminderModelType('reminderSave')
            setShowAutoReminderModal(true)
        }
        const frequencyText = (text) => {
            switch (text) {
                case 'daily':
                    return 'daily'
                case 'every2Days':
                    return 'every 2 days'
                case 'every3Days':
                    return 'every 3 days'
                case 'weekly':
                    return 'weekly'
                case 'biWeekly':
                    return 'bi-weekly'
                default:
                    return 'every 2 days'
            }
        }
        const dateMap = {
            'daily': 1,
            'every2Days': 2,
            'every3Days': 3,
            'weekly': 7,
            'biWeekly': 14
        }
        const reminderModelContent = () => {
            if (reminderModelType === 'sent') {
                return (
                    <div style={{margin: '56px 0 0'}} className='document-reminder-wrap'>
                        <img src='/images/document-send-reminder.svg' />
                        <div style={{fontSize: 20, margin: '40px 0 32px', color: '#000', fontWeight: 600, color: '#000', lineHeight: '22px'}}>Document Request Sent</div>
                        <div style={{maxWidth: 424, fontSize: 16, marginBottom: 32, color: '#000', lineHeight: '22px'}}>Auto-reminders are enabled by default. Borrowers will receive an email reminder {frequencyText(reminderSettings.ReminderFrequency)} for any pending documents.</div>
                        <div style={{gap: '15px', marginBottom: 12}} className='document-reminder-btn'>
                            <Button style={{width: 212}} className="doc-btn-cancel" onClick={showReminderModal}>Update auto-reminder</Button>
                            <Button style={{width: 212}} className="doc-btn-confirm" type="primary" onClick={documentReminderCancel}>OK</Button>
                        </div>
                        <div style={{width: 438, fontSize: 10, margin: '20px 0 12px', color: '#6E6E70'}}>To manage default auto-reminders for future loans, go to <span style={{color: '#325CEB', fontWeight: 600, textDecorationLine: 'underline', cursor: 'pointer'}} onClick={toSettings}>Settings - Feature customization</span></div>
                    </div>
                )
            } else if (reminderModelType === 'oneTime') {
                return (
                    <div style={{margin: '70px 0 0'}} className='document-reminder-wrap'>
                        <img src='/images/document-send-message.svg' />
                        <div style={{maxWidth: 410, fontSize: 16, margin: '46px 0 30px', color: '#000', lineHeight: '24px', textAlign: 'center'}}>Would you like to remind the borrower(s) to upload the requested documents?</div>
                        {getClosestLatestNoticeTime(originalDocumentList) && <div style={{fontSize: 14, margin: '0 0 40px', color: '#6E6E70', lineHeight: '18px', textAlign: 'center'}}>Last reminder was sent on {getClosestLatestNoticeTime(originalDocumentList)}.</div>}
                        <div style={{gap: '20px', marginBottom: 36}} className='document-reminder-btn'>
                            <Button style={{width: 200}} className="doc-btn-cancel" onClick={documentReminderCancel}>Cancel</Button>
                            <Button style={{width: 200}} loading={saveLoading} className="doc-btn-confirm" type="primary" onClick={() => sendReminder('all', 'settings')}>Confirm</Button>
                        </div>
                    </div>
                )
            } else if (reminderModelType === 'reminderSuccess') {
                return (
                    <div style={{margin: '66px 0 0'}} className='document-reminder-wrap'>
                        <img src='/images/document-send-reminder.svg' />
                        <div style={{maxWidth: 430, fontSize: 16, margin: '66px 0 60px', color: '#000', lineHeight: '24px', textAlign: 'center'}}>Email reminder sent successfully for all pending document requests for this loan.</div>
                    </div>
                )
            } else if (reminderModelType === 'turnOff') {
                return (
                    <div style={{margin: '70px 0 0'}} className='document-reminder-wrap'>
                        <img src='/images/document-send-message.svg' />
                        <div style={{maxWidth: 410, fontSize: 16, margin: '50px 0 85px', color: '#000', lineHeight: '24px', textAlign: 'center'}}>Are you sure you want to turn off the auto-reminder for this loan?</div>
                        <div style={{gap: '20px', marginBottom: 40}} className='document-reminder-btn'>
                            <Button style={{width: 200}} className="doc-btn-cancel" onClick={documentReminderCancel}>Cancel</Button>
                            <Button style={{width: 200}} className="doc-btn-confirm" type="primary" onClick={turnOffReminder}>Turn off</Button>
                        </div>
                    </div>
                )
            } else if (reminderModelType === 'reminderSave') {
                return (
                    <div style={{margin: '66px 0 0'}} className='document-reminder-wrap'>
                        <img src='/images/document-send-reminder.svg' />
                        <div style={{fontSize: 20, fontWeight: 600, margin: '42px 0 45px', color: '#222', lineHeight: '24px'}}>Auto-reminder Updated</div>
                        <div style={{maxWidth: 410, fontSize: 16, margin: '0 0 56px', color: '#222', lineHeight: '24px', textAlign: 'center'}}>Auto-reminder setting for this loan has been updated. The next reminder will be sent on {dayjs().add(dateMap[reminderSettings.ReminderFrequency], 'day').format('MM/DD/YYYY')}.</div>
                    </div>
                )
            } else if (reminderModelType === 'reminderEnabled') {
                return (
                    <div style={{margin: '66px 0 0'}} className='document-reminder-wrap'>
                        <img src='/images/document-send-reminder.svg' />
                        <div style={{fontSize: 20, fontWeight: 600, margin: '40px 0 44px', color: '#222', lineHeight: '24px'}}>Auto-reminder Enabled</div>
                        <div style={{fontSize: 16, color: '#222', lineHeight: '24px', textAlign: 'center'}}>Email reminder sent successfully for</div>
                        <div style={{fontSize: 16, margin: '0 0 20px', color: '#222', lineHeight: '24px', textAlign: 'center'}}>all pending document requests for this loan.</div>
                        <div style={{fontSize: 14, margin: '0 0 22px', color: '#6E6E70', lineHeight: '18px', textAlign: 'center'}}>The next reminder will be sent on {dayjs().add(dateMap[reminderSettings.ReminderFrequency], 'day').format('MM/DD/YYYY')}.</div>
                    </div>
                )
            } else if (reminderModelType === 'uploadAll') {
                return (
                    <div style={{margin: '55px 0 0'}} className='document-reminder-wrap'>
                        <div style={{maxWidth: 410, fontSize: 16, margin: '0 0 38px', color: '#000', lineHeight: '24px', textAlign: 'center'}}>It looks like your borrower has uploaded all the documents. If any document doesn't meet your requirements, please request a re-submission.</div>
                        <div style={{marginBottom: 52}} className='document-reminder-btn'>
                            <Button style={{width: 200}} className="doc-btn-confirm" type="primary" onClick={documentReminderCancel}>Confirm</Button>
                        </div>
                    </div>
                )
            }
        }
        const deleteConfirm = () => {
            if (modalType === 'deleteDoc') {
                deletedocument('doc')
            } else {
                deletedocument('file')
            }
        }
        const deletedocument = (type) => {
            let token = sessionStorage.getItem("ZeitroA")
            let api = type === 'doc' ? '/los/deleterequest/' : '/los/deleteuserdocument/'
            fetch(api + currentID, {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache",
                    "Content-Type": "application/json",
                },
            }).then(
                response => {
                    if (response.status !== 200) {
                        return;
                    }
                    message.success({
                        type: 'success',
                        content: 'Delete successful!',
                    })
                    documentChecklistCancel()
                    getdocuments()
                }
            ).catch((err) => {
                
            })
        }
        const showFilter = () => {
            if (originalDocumentList.some(item => item.list.length > 0)) {
                setOpenFilter(true)
            }
        }
        const transitionCancel = () => {
            setHandleTransitionOpen(false)
        }
        const sendReminder = (type, from) => {
            setSaveLoading(true)
            let token = sessionStorage.getItem("ZeitroA")
            let data = {
                LoanID: props.loanid,
                TaskID: type === 'all' ? 0 : currentID
            }
            fetch('/los/senddocumentreminder', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache",
                    "Content-Type": "application/json",
                },
        
            }).then(
                response => {
                    setSaveLoading(false)
                    if (response.status !== 200) {
                        message.error('Something went wrong, please try later')
                        return;
                    }
                    if (response.status === 200 ) {
                        if (from === 'opera') {
                            message.open({
                                icon: null,
                                duration: 2,
                                content: <div style={{display: 'flex', alignItems: 'center', gap: 10}}><span>Reminder sent</span><img src='/images/document/document-check-green.svg' /></div>,
                                className: 'doucument-sent-success',
                            })
                            documentChecklistCancel()
                        } else {
                            reminderConfirm()
                        }
                    }
                }
        
            ).catch((err) => {
                setSaveLoading(false)
                message.error('Something went wrong, please try later')
            })
        }
        const dropdownReminder = [
            {
              label: <div>Send one-time reminder <span style={{fontWeight: 700}}>now</span></div>,
              key: '1',
              disabled: !hasNonEmptyList
            },
            {
              label: 'Change auto-reminder frequency',
              key: '2',
              disabled: !reminderSettings.TurnedOn
            }
        ]
        const hasRequestedStatus = originalDocumentList.some(item =>
            item.list.some(subItem => subItem.Status === "requested")
        )
        const hasDownloadableDocuments = originalDocumentList.some(item =>
            item.list.some(task => (task.Documents || []).length > 0)
        ) || uncategorizedDoc.length > 0
        const handleReminder = (e) => {
            if (e.key === '1') {
                setReminderModalWidth(568)
                if (hasRequestedStatus) {
                    setReminderModelType('oneTime')
                } else {
                    setReminderModelType('uploadAll')
                }
                setHandleReminderOpen(true)
            } else {
                setLastReminder(getClosestLatestNoticeTime(originalDocumentList))
                setReminderModelType('reminderSave')
                setShowAutoReminderModal(true)
            }
        }
        const handleBellClick = () => {
            if (reminderSettings.TurnedOn) {
                setReminderModalWidth(568)
                setReminderModelType('turnOff')
                setHandleReminderOpen(true)
            } else {
                setReminderSettings((prevSettings) => ({
                    ...prevSettings,
                    TurnedOn: true
                }))
                setReminderModelType('reminderEnabled')
                setShowAutoReminderModal(true)
            }
        }
        const handlefilterDropdown = (flag) => {
            setOpenFilter(flag)
        }
        if (batchDownloadOpen) {
            return renderBatchDownloadPage()
        }
        return <div className="currentChecklistWrap document-checklist-v2">
            <Spin spinning={tasksLoading}>
            <Modal
                className={`${modalType === 'action' ? 'action-modal' : 'delete-modal'} document-checklist-modal`}
                centered
                zIndex={1001}
                width={modalType === 'sendReminder' ? 568 : 500}
                open={handleDocumentOpen}
                onCancel={documentChecklistCancel}
                footer={modalType === 'action' ? null : modalType === 'sendReminder' ? [
                    <Button style={{width: 200}} className="doc-btn-cancel" loading={saveLoading} onClick={() => sendReminder('single', 'opera')}>No, send for this one</Button>,
                    <Button style={{width: 200}} className="doc-btn-confirm" type="primary" loading={saveLoading} onClick={() => sendReminder('all', 'opera')}>Yes, include all</Button>
                ] : [
                    <Button style={{width: 128}} className="doc-btn-cancel" onClick={documentChecklistCancel}>Cancel</Button>,
                    <Button className="doc-btn-confirm" type="primary" loading={saveLoading} onClick={deleteConfirm}>Confirm</Button>
                ]}
            >   
                {middleModelContent()}
            </Modal>
            <Modal
                className='document-reminder-modal'
                centered
                zIndex={1001}
                width={reminderModalWidth}
                open={handleReminderOpen}
                onCancel={documentReminderCancel}
                footer={null}
            >   
                {reminderModelContent()}
            </Modal>
            <Modal
                className='transition-modal'
                centered
                maskClosable={false}
                width={706}
                open={handleTransitionOpen}
                onCancel={transitionCancel}
                footer={null}
            >   
                <div className='transition-title'><img src='/images/document/zeitro-logo.svg'/><div className='transition-title-text'>Introducing New <span style={{color: '#1630AC'}}>DOCUMENTS</span></div></div>
                <div className='transition-content'>
                    <div>The "<span className='content-bold'>Create document upload tasks</span>" feature is now integrated into the <span className='content-bold'>Documents</span> page. You can now enjoy AI-powered document requests, reviews, and verification all in one place!</div>
                    <div>To send document requests to your borrowers, simply click " <span className='content-bold'>+ Add Document</span> ".</div>
                    <div>Thanks for being part of our journey to enhance your experience!</div>
                </div>
                <div style={{textAlign: 'center'}}><Button className="transition-btn" type="primary" onClick={transitionCancel} >Got it</Button></div>
            </Modal>
            <div>
                <div className="checklist-title">
                    <span className='checklist-title-l'>Documents</span>
                    <div style={verifiedCount === 0 ? {backgroundColor: '#D6E9FF', color: '#1630AC'} : {color: '#2E605A'}} className='checklist-title-r'><span style={{fontWeight: 600}}>{verifiedCount} / {documentCount}</span><span>documents verified</span>{verifiedCount === documentCount && <img src='/images/all-verified.svg' />}</div>
                </div>
                <div className='add-document-bar'>
                    <div className='add-document-btn' onClick={handleAddBtn}><PlusOutlined />Add document</div>
                    <div className='aciton-bar'>
                        <Dropdown
                            overlayClassName="filter-dropdown"
                            open={openFilter}
                            dropdownRender={filterDropdownContent}
                            placement="bottomRight"
                            onOpenChange={handlefilterDropdown}
                        >
                            <div className={`filter-btn ${hasNonEmptyList ? filterCount() > 0 ? 'select-filter' : '' : 'filter-disable'}`} onClick={showFilter}>
                                <img src={hasNonEmptyList ? '/images/document-filter.svg' : '/images/document-filter-grey.svg'} />All filters
                                {hasNonEmptyList && filterCount() > 0 && <div className='select-count'>{filterCount()}</div>}
                            </div>
                        </Dropdown>
                        <Dropdown.Button
                            onClick={handleBellClick}
                            overlayClassName="document-reminder-dropdown"
                            menu={{
                                items: dropdownReminder,
                                onClick: (e) => handleReminder(e)
                            }}
                            trigger={['click']}
                            buttonsRender={([leftButton, rightButton]) => [
                                <Tooltip 
                                    align={{
                                        offset: [28, 8]
                                    }}
                                    title={`Auto-reminder ${reminderSettings.TurnedOn ? 'on' : 'off'}`}
                                    arrow={false} 
                                    placement="bottomRight"
                                >
                                  {React.cloneElement(leftButton, {
                                        style: {
                                            width: 45,
                                            height: 45,
                                            backgroundColor: '#F7F8FF',
                                            borderRight: '1px solid #FFF',
                                        }
                                    })}
                                </Tooltip>,
                                React.cloneElement(rightButton, {
                                    icon: <img src='/images/document-reminder-select.svg' />,
                                    style: {
                                        width: 28,
                                        height: 45,
                                        backgroundColor: '#F7F8FF',
                                        borderLeft: '1px solid #FFF',
                                    }
                                })
                            ]}
                        >
                            <img src={`/images/document-remind-${reminderSettings.TurnedOn ? 'blue' : 'close'}.svg`} />
                        </Dropdown.Button>
                        <div className={`download-all-btn ${hasDownloadableDocuments ? '' : 'download-all-disable'}`} onClick={hasDownloadableDocuments ? handleDownloadAction : undefined}><img src={`/images/document-download-${hasDownloadableDocuments ? 'blue' : 'disabled'}.svg`} /></div>
                    </div>
                </div>
                {selectedDocumentIDs.length > 0 && (
                    <div className="batch-download-selection-bar">
                        <span className="batch-download-selection-count">{selectedDocumentIDs.length} selected</span>
                        <span className="batch-download-selection-availability">all downloadable</span>
                        <span className="batch-download-selection-divider" aria-hidden="true" />
                        <Button type="primary" onClick={handleDownloadAction}>Download…</Button>
                        <Button type="text" onClick={() => setSelectedDocumentIDs([])}>Clear</Button>
                    </div>
                )}
                <Modal
                    title="Batch download"
                    open={batchDownloadOpen}
                    onCancel={() => setBatchDownloadOpen(false)}
                    onOk={() => downloadBatchDocuments()}
                    okText={batchDownloadLoading ? 'Preparing…' : 'Download'}
                    confirmLoading={batchDownloadLoading}
                    okButtonProps={{ disabled: !selectedDocumentIDs.length }}
                >
                    <p>{selectedDocumentIDs.length} document{selectedDocumentIDs.length === 1 ? '' : 's'} selected.</p>
                    <div className="batch-download-queue">
                        {getSelectedDocumentRecords().map(record => (
                            <div className="batch-download-queue-item" key={record.ID}>
                                <span>{record.FileName}</span>
                                <Button type="text" onClick={() => toggleDocumentSelection(record.ID)}>Remove</Button>
                            </div>
                        ))}
                    </div>
                    <Select
                        style={{ width: '100%' }}
                        value={batchDownloadFormat}
                        onChange={setBatchDownloadFormat}
                        options={[
                            { value: 'zip', label: 'Single ZIP archive (grouped by category)' },
                            { value: 'individual', label: 'Individual files' },
                        ]}
                    />
                    {batchDownloadError && <div style={{ color: '#C62828', marginTop: 12 }}>{batchDownloadError}</div>}
                </Modal>
                <div className='document-checklist'>
                    {
                        uncategorizedDoc.length > 0  && (
                            <div className={`${uncategorizedOpen ? '' : 'uncategorized-expand'} document-table-wrap`}>
                                <Table className='document-table uncategorized-doc'
                                    rowKey="ID"
                                    scroll={{ x: 810 }}
                                    rowHoverable={false}
                                    pagination={false}
                                    columns={uncategorizedColumns}
                                    dataSource={uncategorizedDoc}
                                    rowClassName={(record) => {
                                        const ids = [record.ID, ...(record.Documents || []).map(d => d.ID)].map(String)
                                        return ids.some(id => uploadBatchIDs.includes(id)) ? 'borrower-upload-highlight' : ''
                                    }}
                                />
                            </div>
                        )
                    }
                    {
                        documentList.map(item => {
                            return (
                                item.list.length > 0 ? (
                                    <div className={`${item.open ? '' : 'expand'} document-table-wrap`} key={item.type}>
                                        <Table className={`document-table ${item.type === 'internalDocuments' ? 'internalDocuments' : ''}`}
                                            rowKey="ID"
                                            scroll={{ x: 810 }} 
                                            pagination={false} 
                                            columns={columnsData(item.type)} 
                                            dataSource={item.list}
                                            rowClassName={(record) => {
                                                const hasNewUpload = (record.Documents || []).some(document => uploadBatchIDs.includes(String(document.ID)))
                                                return [
                                                    record.Status === 'verified' ? 'verified-document' : '',
                                                    hasNewUpload ? 'borrower-upload-highlight' : '',
                                                ].filter(Boolean).join(' ')
                                            }}
                                            expandable={{
                                                expandedRowRender,
                                                rowExpandable: (record) => record.Documents.length > 0,
                                                expandIcon: ({ expanded, onExpand, record }) =>
                                                    record.Documents.length === 0 ? null :
                                                    expanded ? (
                                                        <img src='/images/collapse-bottom-arrow-black.svg' onClick={e => onExpand(record, e)} />
                                                ) : (
                                                        <img src='/images/collapse-right-arrow-black.svg' onClick={e => onExpand(record, e)} />
                                                )
                                            }}
                                        />
                                    </div>
                                ) : (
                                    !isFilters && (
                                        <Row className='document-checklist-item'>
                                            <Col className='checklist-item-title'>{com.splitByCapitalLetter(item.type).toUpperCase()}</Col>
                                            <Col className='checklist-item-num'>0 document</Col>
                                        </Row>
                                    )
                                )
                            )
                        })
                    }
                    {documentList.every(item => item.list.length === 0) && isFilters && <Empty style={{margin: '100px 0'}} image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                </div>
            </div>
            </Spin>
        </div>
    }
    const categoryOptions = [
        {
            label: 'Identification',
            value: 'identification'
        },
        {
            label: 'Income',
            value: 'income'
        },
        {
            label: 'Assets',
            value: 'assets'
        },
        {
            label: 'Credit',
            value: 'credit'
        },
        {
            label: 'Property',
            value: 'property'
        },
        {
            label: 'Miscellaneous',
            value: 'miscellaneous'
        },
        {
            label: 'Internal documents',
            value: 'internalDocuments'
        }
    ]
    const timeRangeOptions = [
        {
            label: 'Past 30 days',
            value: 'recent30Days'
        },
        {
            label: 'Past 2 months',
            value: 'recent2Months'
        },
        {
            label: 'Past 3 months',
            value: 'recent3Months'
        },
        {
            label: 'Past 6 months',
            value: 'recent6Months'
        },
        {
            label: 'Past year',
            value: 'recent1Year'
        },
        {
            label: 'Past 2 years',
            value: 'recent2Years'
        }
    ]
    const statusFilterOptions = [
        {
            label: 'Pending internal upload',
            value: 'pendingUpload'
        },
        {
            label: 'Uploaded',
            value: 'uploaded'
        },
        {
            label: 'Requested',
            value: 'requested'
        },
        {
            label: 'Re-requested',
            value: 'resubmit'
        },
        {
            label: 'Ready for review',
            value: 'readyForReview'
        },
        {
            label: 'Verified',
            value: 'verified'
        }
    ]
    const handleDelete = (index) => {
        if (editingRow !== -1 && editingRow !== index) {
            const documentToSave = taskDocuments[editingRow]
            const { name, category } = documentToSave
            let hasError = false
            const newFieldErrors = { name: false, category: false }

            if (!name) {
                newFieldErrors.name = true
                hasError = true
            }

            if (!category) {
                newFieldErrors.category = true
                hasError = true
            }

            setFieldErrors(newFieldErrors)

            if (hasError) {
                return
            }
        }
        const updatedTaskDocuments = [...taskDocuments]
        updatedTaskDocuments.splice(index, 1)
        setEditingRow(-1)
        setTaskDocuments(updatedTaskDocuments)
    }
    const handleEdit = (index) => {
        if (editingRow !== -1) {
            setHoveringCell({ row: null, col: null })
            const documentToSave = taskDocuments[editingRow]
            const { name, category, timeRange } = documentToSave
            let hasError = false
            const newFieldErrors = { name: false, category: false }

            if (!name) {
                newFieldErrors.name = true
                hasError = true
            }

            if (!category) {
                newFieldErrors.category = true
                hasError = true
            }

            setFieldErrors(newFieldErrors)

            if (hasError) {
                return
            }
            const filteredTaskDocuments = taskDocuments.filter((_, i) => i !== editingRow)
            if (documentList.some(item => item.list.some(task => task.TaskName === name && task.TimeRange === timeRange)) || filteredTaskDocuments.some(task => task.name === name && task.timeRange === timeRange)) {
                message.warning({
                    content: `A ${name} is already included in your list of requested documents.`,
                })
                return
            }
        }
        handleEditRow(index)
    }
    const addRequest = () => {
        form.validateFields().then((values) => {
            const addDocument = createEmptyDocumentRequest({
                name: values.name || '',
            })
            const updatedTaskDocuments = [...taskDocuments, addDocument]
            setTaskDocuments(updatedTaskDocuments)
            setEditingRow(updatedTaskDocuments.length - 1)
        })
        .catch((errorInfo) => {
            
        })
    }
    const isConfigured = (data) => {
        const { ReminderFrequency, EndWhen } = data
        const isReminderFrequencyEmpty = ReminderFrequency === ''
        const isEndWhenValuesNull = Object.values(EndWhen).every(value => value === null)
        if (isReminderFrequencyEmpty && isEndWhenValuesNull) {
            return false
        }
        return true
    }
    function getClosestLatestNoticeTime(dataArray) {
        let noticeTimes = []
        dataArray.forEach(group => {
            group.list.forEach(item => {
                if (item.LatestNoticeTime) {
                    noticeTimes.push(new Date(item.LatestNoticeTime))
                }
            })
        })
        if (noticeTimes.length === 0) {
            return null
        }
        let currentTime = new Date()
        let closestTime = noticeTimes.reduce((prev, curr) => {
            return Math.abs(curr - currentTime) < Math.abs(prev - currentTime) ? curr : prev
        })
        return dayjs(closestTime).format('MM/DD/YYYY')
    }
    const getLoanAutoReminderConfiguration = () => {
        let token = sessionStorage.getItem("ZeitroA")
        fetch('/los/handleGetLoanAutoReminderConfiguration/'+props.loanid, {
            method: 'GET',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            }
        }).then(
            response => {
                response.json().then(js => {
                    if (js.error) return
                    setCurrentConfiguration(js)
                    if (isConfigured(js)) {
                        setWhenLoanFunded(js.EndWhen.WhenLoanFunded === false ? false : true)
                        let data = {
                            ...js,
                            EndWhen: {
                                ...js.EndWhen,
                                AfterNumberOfDays: null
                            }
                        }
                        setReminderSettings(data)
                    } else {
                        getFeaturecustomization()
                    }
                })
            }
        ).catch((err) => {
            
        })
    }
    const setLoanAutoReminderConfiguration = (data, from) => {
        let token = sessionStorage.getItem("ZeitroA")
        fetch('/los/handleSetLoanAutoReminderConfiguration/'+props.loanid, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
    
        }).then(
            response => {
                if (response.status !== 200) {
                    return
                }
                getLoanAutoReminderConfiguration()
                if (from === 'settings') {
                    setShowAutoReminderModal(false)
                    setReminderModalWidth(500)
                    setHandleReminderOpen(true)
                    setTimeout(() => {
                        if (reminderModelType === 'reminderSave' || reminderModelType === 'reminderEnabled') {
                            setHandleReminderOpen(false)
                        }
                    }, 5000)
                } else if (from === 'TurnedOff') {
                    documentReminderCancel()
                    message.open({
                        icon: null,
                        duration: 2,
                        content: <div style={{display: 'flex', alignItems: 'center', gap: 10}}><span>Auto-reminder off</span><img src='/images/document-remind-close-white.svg' /></div>,
                        className: 'auto-reminder-off',
                    })
                }
            }
        ).catch((err) => {
   
        })
    }
    const getFeaturecustomization = () => {
        let token = sessionStorage.getItem("ZeitroA")
        fetch('/los/getfeaturecustomization', {
            method: 'get',
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
        }).then(
            response => {
                response.json().then(js => {
                    if (js.error) return
                    if (isConfigured(js.DocumentsAutoReminder)) {
                        setWhenLoanFunded(js.DocumentsAutoReminder.EndWhen.WhenLoanFunded === false ? false : true)
                        let data = {
                            ...js.DocumentsAutoReminder,
                            EndWhen: {
                                ...js.DocumentsAutoReminder.EndWhen,
                                WhenLoanFunded: js.DocumentsAutoReminder.EndWhen.WhenLoanFunded === false ? true : js.DocumentsAutoReminder.EndWhen.WhenLoanFunded,
                                AfterNumberOfDays: null
                            }
                        }
                        setLoanAutoReminderConfiguration(data, 'init')
                        setReminderSettings(data)
                    } else {
                        setLoanAutoReminderConfiguration({
                            ...reminderSettings,
                            EndWhen: {
                                ...reminderSettings.EndWhen,
                                AfterNumberOfDays: null
                            }
                        }, 'init')
                        setFeaturecustomization({
                            ...reminderSettings,
                            EndWhen: {
                                ...reminderSettings.EndWhen,
                                WhenDate: null
                            }
                        })
                    }
                })
            }
        )
    }
    const setFeaturecustomization = (data) => {
        let bodyData = {
            ...currentConfiguration,
            DocumentsAutoReminder: {
                ...data,
                EndWhen: {
                    WhenDate: null
                }
            }
        }
        let token = sessionStorage.getItem("ZeitroA")
        fetch(`/los/setfeaturecustomization`, {
            method: 'POST',
            body: JSON.stringify(bodyData),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache"
            }
    
        }).then(
            response => {
                if (response.status !== 200) {
                    return
                }
            }
    
        ).catch((err) => {
   
        })
    }
    const getLastReminder = () => {

    }
    const clearAppliedDocumentTemplate = () => {
        setAppliedDocumentTemplate(null)
        setAppliedDocumentTemplateItems([])
        setApplyingDocumentTemplateID('')
    }
    const resetDocumentChecklist = () => {
        setTaskDocuments([createEmptyDocumentRequest()])
        clearAppliedDocumentTemplate()
        setEditingRow(0)
        setFieldErrors({ name: false, category: false })
        setShowSaveDocumentTemplateModal(false)
    }
    const getAutogenerateDoc = () => {
        setLoading(true)
        getLosDocumentAutotasksV2(props.loanid)
            .then((body) => {
                setLoading(false)
                const data = body?.Suggestions || []
                clearAppliedDocumentTemplate()
                setEditingRow(-1)
                setFieldErrors({ name: false, category: false })
                if (data.length > 0) {
                    const autoDocuments = data.map((doc, index) => ({
                        key: index,
                        name: doc.TaskName,
                        category: doc.Category,
                        timeRange: doc.TimeRange,
                        description: doc.Description,
                    }))
                    setTaskDocuments(autoDocuments)
                    message.success({
                        content: `Documents successfully auto-generated.`,
                    })
                } else {
                    resetDocumentChecklist()
                    modal.confirm({
                        title: 'Document requests cannot be automatically generated at this time due to one of two reasons:',
                        icon: null,
                        content: <div><div>1. All relevant documents have already been requested.</div><div>2. The borrower's information is incomplete.</div></div>,
                        cancelButtonProps: { style: { display: 'none' } },
                    })
                }
            })
            .catch((err) => {
                setLoading(false)
                resetDocumentChecklist()
                message.error(err?.message || 'Failed to auto-generate documents.')
            })
    }
    const autoGenerateDocumentChecklist = () => {
        if (!documentRequestHasContent(taskDocuments)) {
            getAutogenerateDoc()
            return
        }
        modal.confirm({
            title: 'Replace the current document list?',
            content:
                'Auto-generated documents will replace the rows currently in this request.',
            okText: 'Auto-generate',
            cancelText: 'Cancel',
            onOk: getAutogenerateDoc,
        })
    }
    const disabledDate = (current) => {
        return current && current < dayjs().endOf('day');
    }
    const applyDocumentTemplateDetail = async (
        template,
        source,
        metadata = {}
    ) => {
        setApplyingDocumentTemplateID(template.id)
        try {
            const templateDetail = await getDocumentTemplate(template.id)
            const templateItems = templateDetail.items || []
            setTaskDocuments(templateItemsToTaskDocuments(templateItems))
            setAppliedDocumentTemplate(templateDetail)
            setAppliedDocumentTemplateItems(
                templateItems.map((item) => ({ ...item }))
            )
            setEditingRow(-1)
            setFieldErrors({ name: false, category: false })
            logDocumentTemplateEvent(client, 'template_applied', {
                template: templateDetail,
                source,
                metadata,
            })
            track(STATSIG.LOAN.DOCUMENT_TEMPLATE, {
                type: 'applied',
                source,
            })
            return true
        } catch (requestError) {
            message.error(
                requestError.message || 'Unable to apply the template.'
            )
            return false
        } finally {
            setApplyingDocumentTemplateID('')
        }
    }
    const loadActiveDocumentTemplates = async ({
        autoApplyDefault = false,
        trackSuggestions = true,
    } = {}) => {
        setDocumentTemplatesLoading(true)
        setDocumentTemplatesError('')
        try {
            const templates = await listDocumentTemplates({
                status: DOCUMENT_TEMPLATE_STATUS.ACTIVE,
            })
            if (!documentTemplateMountedRef.current) return
            setDocumentTemplates(templates)
            if (trackSuggestions) logTemplateSuggestions(templates)
            if (trackSuggestions && templates.length > 0) {
                track(STATSIG.LOAN.DOCUMENT_TEMPLATE, {
                    type: 'suggested',
                    source: 'add_document_request',
                })
            }
            if (autoApplyDefault) {
                const defaultTemplate =
                    getHighestMatchingDefaultDocumentTemplate(
                        templates,
                        documentTemplateRecommendationContext
                    )
                if (defaultTemplate) {
                    await applyDocumentTemplateDetail(
                        defaultTemplate,
                        'add_document_request',
                        { application_method: 'automatic_default' }
                    )
                }
            }
        } catch (requestError) {
            if (!documentTemplateMountedRef.current) return
            setDocumentTemplatesError(
                requestError.message || 'Unable to load templates.'
            )
        } finally {
            if (documentTemplateMountedRef.current) {
                setDocumentTemplatesLoading(false)
            }
        }
    }
    const changeDocumentTemplateRecommendationState = (nextState) => {
        const nextContext = {
            ...documentTemplateRecommendationContext,
            state: nextState,
        }

        setDocumentTemplateRecommendationState(
            nextState === documentTemplateLoanContext.state ? '' : nextState
        )
        logTemplateSuggestions(documentTemplates, nextContext)
    }
    const confirmTemplateChecklistReplacement = (action, title) => {
        if (!appliedDocumentTemplateEdited) {
            return action()
        }
        return new Promise((resolve) => {
            modal.confirm({
                title,
                content:
                    'Your changes to the current checklist will be discarded.',
                okText: 'Continue',
                cancelText: 'Cancel',
                onOk: async () => resolve(await action()),
                onCancel: () => resolve(false),
            })
        })
    }
    const applyDocumentTemplate = (template) =>
        confirmTemplateChecklistReplacement(
            () => applyDocumentTemplateDetail(template, 'template_picker'),
            `Change to "${template.name}"?`
        )
    const clearDocumentTemplate = () =>
        confirmTemplateChecklistReplacement(() => {
            resetDocumentChecklist()
            return true
        }, 'Clear this checklist?')
    const clearDocumentRequestChecklist = () => {
        if (
            !documentRequestHasContent(taskDocuments) &&
            !appliedDocumentTemplate
        ) return
        modal.confirm({
            title: 'Clear the document list?',
            content:
                'This removes every row from the current request and clears the selected template.',
            okText: 'Clear list',
            okButtonProps: { danger: true },
            cancelText: 'Cancel',
            onOk: resetDocumentChecklist,
        })
    }
    const handleDocumentTemplateSaved = async (savedTemplate, mode) => {
        track(STATSIG.LOAN.DOCUMENT_TEMPLATE, {
            type: 'saved',
            source: 'document_request',
        })
        logDocumentTemplateEvent(client, 'template_saved', {
            template: savedTemplate,
            source: 'document_request',
            value: mode,
            metadata: { save_mode: mode },
        })
        setShowSaveDocumentTemplateModal(false)
        setAppliedDocumentTemplate(savedTemplate)
        setAppliedDocumentTemplateItems(
            (savedTemplate.items?.length
                ? savedTemplate.items
                : taskDocuments
            ).map((item) => ({ ...item }))
        )
        await loadActiveDocumentTemplates({ trackSuggestions: false })
    }
    const isHeicOrHeif = (fileName) => {
        return /\.(heic|heif)$/i.test(fileName)
    }
    const draggerProps = {
        fileList: fileList,
        multiple: true,
        showUploadList: false,
        onChange(info) {
            const fileList = [...info.fileList]
            setFileList(fileList)
        },
        onDrop(e) {
            
        },
        beforeUpload: async (file) => {
            if(isHeicOrHeif(file?.name?.toLowerCase())) {
                let blob = undefined
                try {
                    blob = await heic2any({ blob: file, toType: "image/png" })
                } catch(error) {
                    message.warning("You can only upload image and PDF files.")
                    return Upload.LIST_IGNORE
                }
                const convertedFile = new File([blob], file?.name?.replace(/\.(heic|heif)$/i, ".png"), {
                    type: "image/png",
                });
                return convertedFile
            } else {
                const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf']
                const fileType = file.type
                const isAllowed = allowedFileTypes.includes(fileType)
                if (!isAllowed) {
                    message.warning('You can only upload image and PDF files.')
                    return Upload.LIST_IGNORE
                }
            }
            return true
        },
    }

    const handleValuesChange = (changedValues, allValues) => {
        if (allValues.recipient === 'borrower') {
            setAddType(1)
        } else {
            setAddType(2)
        }
    }
    const validateForm = () => {
        form.validateFields().then((values) => {
            if (editMode === 'add') {
                updateDocRequest()
                return
            }
            if (handleDocumentSelect === 'add') {
                addDocRequest()
            } else if (handleDocumentSelect === 'upload') {
                uploadDocuments()
            } else {
                requestresubmit()
            }
        })
        .catch((errorInfo) => {
            
        })
    }
    const resetForm = () => {
        form.resetFields()
    }
    const editField = (index, newValue, key) => {
        const newData = [...taskDocuments]
        newData[index][key] = newValue
        setTaskDocuments(newData)
        setFieldErrors((prevErrors) => ({ ...prevErrors, [key]: false }))
    }
    const getLabelByValue = (options, value) => {
        const foundOption = options.find(option => option.value === value)
        return foundOption ? foundOption.label : null
    }
    const handleRowSave = (index) => {
        const documentToSave = taskDocuments[index];
        const { name, category, timeRange } = documentToSave;
        let hasError = false;
        const newFieldErrors = { name: false, category: false };

        if (!name) {
            newFieldErrors.name = true;
            hasError = true;
        }

        if (!category) {
            newFieldErrors.category = true;
            hasError = true;
        }

        setFieldErrors(newFieldErrors);

        if (hasError) {
            return;
        }
        const filteredTaskDocuments = taskDocuments.filter((_, i) => i !== index)
        if (documentList.some(item => item.list.some(task => task.TaskName === name && task.TimeRange === timeRange)) || filteredTaskDocuments.some(task => task.name === name && task.timeRange === timeRange)) {
            message.warning({
                content: `A ${name} is already included in your list of requested documents.`,
            })
            return
        }
        setEditingRow(-1)
    }

    const getDocumentOptions = () => {
        const options = com.documentsList.map(document => ({
            value: document,
            label: document
        }));

        // Legacy: primary + single coborrower named variants (unchanged strings).
        if (props.application.hascoborrower === "withcoborrower") {
            com.documentsList.forEach(document => {
                options.push({
                    value: `${document} - ${props.application.borrower.firstname} ${props.application.borrower.lastname.charAt(0)}.`,
                    label: `${document} - ${props.application.borrower.firstname} ${props.application.borrower.lastname.charAt(0)}.`
                })
                options.push({
                    value: `${document} - ${props.application.coborrower.firstname} ${props.application.coborrower.lastname.charAt(0)}.`,
                    label: `${document} - ${props.application.coborrower.firstname} ${props.application.coborrower.lastname.charAt(0)}.`
                })
            })
        }

        // Multi-coborrower: append named variants for additional V2 coborrowers only.
        const legacyCoSuffix = props.application.hascoborrower === "withcoborrower"
            ? `${props.application.coborrower.firstname} ${props.application.coborrower.lastname.charAt(0)}.`
            : ""
        const legacyPrimarySuffix = `${props.application.borrower.firstname} ${props.application.borrower.lastname.charAt(0)}.`
        const extraSubjects = documentSubjects.filter((s) => {
            if (s.isPrimary) return false
            if (s.suffix === legacyCoSuffix || s.suffix === legacyPrimarySuffix) return false
            return true
        })
        if (extraSubjects.length > 0) {
            // Ensure primary named variants exist even if hascoborrower flag is unset but V2 has cos.
            if (props.application.hascoborrower !== "withcoborrower") {
                const primary = documentSubjects.find((s) => s.isPrimary) || {
                    firstName: props.application.borrower.firstname,
                    lastName: props.application.borrower.lastname,
                    suffix: legacyPrimarySuffix,
                }
                const allForNames = [primary, ...extraSubjects]
                com.documentsList.forEach((document) => {
                    allForNames.forEach((subject) => {
                        const named = documentNameWithSubject(document, subject)
                        if (!options.some((o) => o.value === named)) {
                            options.push({ value: named, label: named })
                        }
                    })
                })
            } else {
                com.documentsList.forEach((document) => {
                    extraSubjects.forEach((subject) => {
                        const named = documentNameWithSubject(document, subject)
                        if (!options.some((o) => o.value === named)) {
                            options.push({ value: named, label: named })
                        }
                    })
                })
            }
        }

        setDocumentOptions(options.sort((a, b) => a.value.localeCompare(b.value)))
        setDocumentOptionsOriginal(options.sort((a, b) => a.value.localeCompare(b.value)))
    }
    const updateDocOptions = (value) => {
        if (!value) {
            getDocumentOptions()
            return
        }
        if (value && !documentOptions.some(option => option.value === value)) {
            const newOptions = [...documentOptionsOriginal, { value, label: value }]
            if (props.application.hascoborrower === "withcoborrower") {
                newOptions.push(
                    { value: `${value} - ${props.application.borrower.firstname} ${props.application.borrower.lastname.charAt(0)}.`, label: `${value} - ${props.application.borrower.firstname} ${props.application.borrower.lastname.charAt(0)}.` },
                    { value: `${value} - ${props.application.coborrower.firstname} ${props.application.coborrower.lastname.charAt(0)}.`, label: `${value} - ${props.application.coborrower.firstname} ${props.application.coborrower.lastname.charAt(0)}.` }
                );
            }
            const legacyCoSuffix = props.application.hascoborrower === "withcoborrower"
                ? `${props.application.coborrower.firstname} ${props.application.coborrower.lastname.charAt(0)}.`
                : ""
            const legacyPrimarySuffix = `${props.application.borrower.firstname} ${props.application.borrower.lastname.charAt(0)}.`
            documentSubjects
                .filter((s) => !s.isPrimary && s.suffix !== legacyCoSuffix && s.suffix !== legacyPrimarySuffix)
                .forEach((subject) => {
                    const named = documentNameWithSubject(value, subject)
                    if (!newOptions.some((option) => option.value === named)) {
                        newOptions.push({ value: named, label: named })
                    }
                })
            setDocumentOptions(newOptions.sort((a, b) => a.value.localeCompare(b.value)))
        }
    }
    const docuemntNameChange = (index, value) => {
        editField(index, value, 'name')
        updateDocOptions(value)
    }
    const taskDocumentsColumns = [
        {
            title: `Document (${taskDocuments.filter((document) =>
                documentRequestHasContent([document])
            ).length})`,
            dataIndex: 'name',
            key: 'name',
            width: 250,
            render: (text, record, index) => {
                const isHovered = hoveringCell.row === index && hoveringCell.col === 'name'
                if (index === editingRow || isHovered) {
                    return (
                        <div style={{position: 'relative'}}>
                            <AutoComplete
                                className={index === editingRow ? 'borrower-doc-input' : 'borrower-doc-input hover'}
                                options={documentOptions}
                                style={{
                                    width: '100%',
                                    height: '40px'
                                }}
                                value={text}
                                status={fieldErrors.name && (text === undefined || text === '') ? 'error' : ''}
                                filterOption={(inputValue, option) =>
                                    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                }
                                onChange={(e) => {
                                    docuemntNameChange(index, e)
                                }}
                            />
                            {
                                isHovered && <div className='hover-mask' onMouseLeave={() => setHoveringCell({ row: null, col: null })} onClick={() => handleEdit(index)}></div>
                            }
                        </div>
                    )
                } else {
                    return (
                        <Tooltip arrow={false} placement="bottomLeft" title={text}>
                            <div 
                                className='table-message'
                                onMouseEnter={() => setHoveringCell({ row: index, col: 'name' })}
                            >
                                <div className='msg-content'>{text}</div>
                            </div>
                        </Tooltip>
                    )   
                }
            },
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            width: 130,
            render: (text, record, index) => {
                const isHovered = hoveringCell.row === index && hoveringCell.col === 'category'
                if (index === editingRow || isHovered) {
                    return (
                        <div style={{position: 'relative'}}>
                            <Select
                                value={text}
                                className={index === editingRow ? 'borrower-doc-select' : 'borrower-doc-select hover'}
                                style={{
                                    width: '100%',
                                    height: '40px',
                                }}
                                status={fieldErrors.category && text === undefined ? 'error' : ''}
                                onChange={(e) => {
                                    editField(index, e, 'category')
                                }}
                                placeholder="Select"
                                options={categoryOptions.filter(option => option.value !== 'internalDocuments')}
                            />
                            {
                                isHovered && <div className='hover-mask' onMouseLeave={() => setHoveringCell({ row: null, col: null })} onClick={() => handleEdit(index)}></div>
                            }
                        </div>
                    )
                } else {
                    return (
                        <div 
                            className='table-message'
                            onMouseEnter={() => setHoveringCell({ row: index, col: 'category' })}
                        >
                            <div className='msg-content'>{getLabelByValue(categoryOptions, text)}</div>
                        </div>
                    )
                }
            }
        },
        {
            title: 'Time frame',
            dataIndex: 'timeRange',
            key: 'timeRange',
            width: 150,
            render: (text, record, index) => {
                const isHovered = hoveringCell.row === index && hoveringCell.col === 'timeRange'
                if (index === editingRow || isHovered) {
                    return (
                        <div style={{position: 'relative'}}>
                            <Select
                                value={text}
                                className={index === editingRow ? 'borrower-doc-select' : 'borrower-doc-select hover'}
                                style={{ height: '40px', width: '100%' }}
                                allowClear
                                onChange={(e) => {
                                    editField(index, e, 'timeRange')
                                }}
                                placeholder="Select"
                                options={timeRangeOptions}
                            />
                            {
                                isHovered && <div className='hover-mask' onMouseLeave={() => setHoveringCell({ row: null, col: null })} onClick={() => handleEdit(index)}></div>
                            }
                        </div>
                    )
                } else {
                    return (
                        <div 
                            className='table-message'
                            onMouseEnter={() => setHoveringCell({ row: index, col: 'timeRange' })}
                        >
                            <div style={{color: '#4F4F4F'}} className='msg-content'>{getLabelByValue(timeRangeOptions, text)}</div>
                        </div>
                    )
                }
            }
        },
        {
            title: 'Message to borrower (optional)',
            dataIndex: 'description',
            key: 'description',
            width: 240,
            render: (text, record, index) => {
                const isHovered = hoveringCell.row === index && hoveringCell.col === 'description'
                if (index === editingRow || isHovered) {
                    return (
                        <div style={{position: 'relative'}}>
                            <Input
                                type="text"
                                style={ index === editingRow ? { height: '40px', border: '1px solid #325CEB' } : {height: '40px', border: '1px solid #DBDCDE'}}
                                value={text}
                                onChange={(e) => {
                                    const newValue = e.target.value
                                    editField(index, newValue, 'description')
                                }}
                                placeholder="Optional"
                            />
                            {
                                isHovered && <div className='hover-mask' onMouseLeave={() => setHoveringCell({ row: null, col: null })} onClick={() => handleEdit(index)}></div>
                            }
                        </div>
                    )
                } else {
                    return (
                        <Tooltip arrow={false} placement="bottomLeft" title={text}>
                            <div 
                                className='table-message'
                                onMouseEnter={() => setHoveringCell({ row: index, col: 'description' })}
                            >
                                <div style={{ color: '#4F4F4F' }} className='msg-content'>{text}</div>
                            </div>
                        </Tooltip>
                    ) 
                }
            }
        },
        {
            title: '',
            dataIndex: '',
            key: '',
            fixed: 'right',
            width: 96,
            render: (_, record, index) => {
                return (
                    <div>
                        {index === editingRow ? (
                            <img style={{width: 24, height: 24, cursor: 'pointer', marginRight: 10}} src="/images/document-check.svg" onClick={() => handleRowSave(index)} />
                        ) : (
                            <img style={{width: 20, height: 20, cursor: 'pointer', marginRight: 15}} src="/images/document-edit.svg" onClick={() => handleEdit(index)} />
                        )}
                        <img style={{width: 24, height: 24, cursor: 'pointer'}} onClick={() => handleDelete(index)} src="/images/document-remove.svg" />
                    </div>
                )
            },
        },
    ]
    const handleEditRow = (index) => {
        setEditingRow(index)
    }
    const handleDeleteDoc = (index) => {
        const updatedFile = [...fileList]
        updatedFile.splice(index, 1)
        setFileList(updatedFile)
        form.setFieldsValue({ selectFile: updatedFile })
    }
    const removeFileExtension = (fileName) => {
        return fileName.replace(/\.[^/.]+$/, "")
    }
    const categoryChange = (value) => {
        form.setFieldsValue({
            HideForBorrower: value === 'internalDocuments'
        })
    }
    const hideForBoChange = (e) => {
        form.setFieldsValue({
            category: e.target.checked ? 'internalDocuments' : undefined
        })
    }
    const showCreateNewTasks = () => {
        return (
            <div className="task-modal-wrap">
                <Spin
                    className="task-spin"
                    size="large"
                    tip={
                        documentTemplatesLoading
                            ? 'Loading document templates'
                            : 'Auto generating documents for your task'
                    }
                    spinning={loading || documentTemplatesLoading}
                >
                <Form
                    className='task-form'
                    form={form}
                    onValuesChange={handleValuesChange}
                >
                    <div className="create-task-title">{handleDocumentSelect === 'add' ?  `${editMode === 'add' ? 'Edit' : 'Add'} document request` : handleDocumentSelect === 'upload' ? 'Upload document' : 'Request resubmission'}</div>
                    <div className="create-task-content">
                        {handleDocumentSelect === 'add' &&
                            addType === 1 &&
                            editMode !== 'add' && (
                                <DocumentTemplateStarter
                                    appliedTemplate={appliedDocumentTemplate}
                                    applyingTemplateID={applyingDocumentTemplateID}
                                    context={documentTemplateRecommendationContext}
                                    edited={appliedDocumentTemplateEdited}
                                    error={documentTemplatesError}
                                    loanState={documentTemplateLoanContext.state}
                                    loading={documentTemplatesLoading}
                                    onApply={applyDocumentTemplate}
                                    onBrowseAll={() =>
                                        history.push({
                                            pathname: '/app/creditpullsetting',
                                            state: {
                                                selected: 'documentTemplates',
                                                documentTemplateLoanID:
                                                    props.loanid,
                                            },
                                        })
                                    }
                                    onChangeContextState={
                                        changeDocumentTemplateRecommendationState
                                    }
                                    onClear={clearDocumentTemplate}
                                    onRetry={() =>
                                        loadActiveDocumentTemplates({
                                            autoApplyDefault: true,
                                        })
                                    }
                                    templates={sortedDocumentTemplates}
                                />
                            )}
                        {
                            handleDocumentSelect === 'add' && (
                                <Row gutter={20}>
                                    <Col className="gutter-row" span={24} md={12}>
                                        <div className="form-item-label">Assign to</div>
                                        <Form.Item
                                            name="recipient" 
                                            rules={[
                                                {
                                                    required: true,
                                                    message: `Recipients is required.`,
                                                }
                                            ]}
                                        >
                                            <Select
                                                className="task-select"
                                                style={{
                                                    width: '100%',
                                                }}
                                                placeholder="Select recipients of the request"
                                                options={recipientOptions}
                                            />
                                        </Form.Item>
                                        </Col>
                                        {
                                            editMode !== 'add' && (
                                                <Col className="gutter-row" span={24} md={12}>
                                                    <div className="form-item-label">Due date</div>
                                                    <Form.Item
                                                        name="deadline"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: `Due date is required.`,
                                                            }
                                                        ]}
                                                    >
                                                        <DatePicker
                                                            style={{width: '100%'}}
                                                            className='task-date'
                                                            disabledDate={disabledDate}
                                                            placeholder="MM/DD/YYYY"
                                                            format={{
                                                                format: "MM/DD/YYYY",
                                                                type: 'mask',
                                                            }}
                                                            suffixIcon={null}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            )
                                        }
                                </Row>
                            )
                        }
                        {
                            ((handleDocumentSelect === 'add' && addType !== 1) || handleDocumentSelect === 'upload' || handleDocumentSelect === 'resubmission' || editMode === 'add') && (
                                <Row gutter={20}>
                                    <Col className="gutter-row" span={24} md={12}>
                                        <div className="form-item-label">Document name</div>
                                        {
                                            editMode === 'upload' || editMode === 'resubmission' ? (
                                                <div className='edit-wrap'>{form.getFieldValue('name')}</div>
                                            ) : (
                                                <Form.Item
                                                    name="name"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: `Document name is required.`,
                                                        }
                                                    ]}
                                                >
                                                    <AutoComplete
                                                        className='task-select'
                                                        options={documentOptions}
                                                        style={{
                                                            width: '100%',
                                                            height: '52px'
                                                        }}
                                                        placeholder="Select or enter document name"
                                                        filterOption={(inputValue, option) =>
                                                            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                                        }
                                                        onChange={(e) => {
                                                            updateDocOptions(e)
                                                        }}
                                                    />
                                                </Form.Item>
                                            )
                                        }
                                    </Col>
                                    <Col className="gutter-row" span={24} md={12}>
                                        <div className="form-item-label">Category</div>
                                        {
                                            editMode === 'upload' || editMode === 'resubmission' ? (
                                                <div className='edit-wrap'>{getLabelByValue(categoryOptions, form.getFieldValue('category'))}</div>
                                            ) : (
                                                <Form.Item
                                                    name="category" 
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: `Category is required.`,
                                                        }
                                                    ]}
                                                >
                                                    <Select
                                                        className='task-select'
                                                        style={{
                                                        width: '100%',
                                                        }}
                                                        placeholder="Select category"
                                                        options={categoryOptions}
                                                        onChange={categoryChange}
                                                    />
                                                </Form.Item>
                                            )
                                        }
                                    </Col>
                                    {
                                        editMode === 'add' && (
                                            <>
                                                <Col className="gutter-row" span={24} md={12}>
                                                    <div className="form-item-label">Time frame</div>
                                                    <Form.Item
                                                        name="timerange" 
                                                    >
                                                        <Select
                                                            className="task-select"
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            allowClear
                                                            placeholder="Select time range"
                                                            options={timeRangeOptions}
                                                        />
                                                    </Form.Item>
                                                    </Col>
                                                <Col className="gutter-row" span={24} md={12}>
                                                    <div className="form-item-label">Due date</div>
                                                        <Form.Item
                                                            name="deadline"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: `Due date is required.`,
                                                                }
                                                            ]}
                                                        >
                                                            <DatePicker
                                                                style={{width: '100%'}}
                                                                className='task-date'
                                                                disabledDate={disabledDate}
                                                                placeholder="MM/DD/YYYY"
                                                                format={{
                                                                    format: "MM/DD/YYYY",
                                                                    type: 'mask',
                                                                }}
                                                                suffixIcon={null}
                                                            />
                                                        </Form.Item>
                                                </Col>
                                            </>
                                        )
                                    }
                                    {
                                        handleDocumentSelect === 'resubmission' ? (
                                            <>
                                                <Col className="gutter-row" span={24} md={12}>
                                                    <div className="form-item-label">Files to be re-requested (optional)</div>
                                                    <Form.Item
                                                        name="Files" 
                                                    >
                                                        <Select
                                                            className="task-select"
                                                            style={{
                                                                width: '100%',
                                                                height: 'auto'
                                                            }}
                                                            
                                                            mode="multiple"
                                                            maxTagCount='responsive'
                                                            maxTagTextLength={30}
                                                            placeholder="Select files that need to be re-requested"
                                                            suffixIcon={<DownOutlined />}
                                                            options={handleDocumentList.map(item => ({label: item.FileName, value: item.ID}))}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col className="gutter-row" span={24} md={12}>
                                                    <div className="form-item-label">Due date</div>
                                                    <Form.Item
                                                        name="deadline"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: `Due date is required.`,
                                                            }
                                                        ]}
                                                    >
                                                        <DatePicker
                                                            style={{width: '100%'}}
                                                            className='task-date'
                                                            disabledDate={disabledDate}
                                                            placeholder="MM/DD/YYYY"
                                                            format={{
                                                                format: "MM/DD/YYYY",
                                                                type: 'mask',
                                                            }}
                                                            suffixIcon={null}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col className="gutter-row" span={24} md={24}>
                                                    <div className="form-item-label">Message to borrower (optional)</div>
                                                    <Form.Item
                                                        name="description" 
                                                    >
                                                        <TextArea className='document-input' rows={4} placeholder="Optional document description..." />
                                                    </Form.Item>
                                                </Col>
                                            </>
                                        ) : (
                                            <Col className="gutter-row" span={24} md={24}>
                                                <div className="form-item-label">Description</div>
                                                {
                                                    editMode === 'upload' ? (
                                                        <div className='edit-wrap'>{form.getFieldValue('description') === '' || form.getFieldValue('description') === 'undefined' ? '-' : form.getFieldValue('description')}</div>
                                                    ) : (
                                                        <Form.Item
                                                            name="description" 
                                                        >
                                                            <TextArea className='document-input' rows={4} placeholder="Optional document description..." />
                                                        </Form.Item>
                                                    )
                                                }
                                            </Col>
                                        )
                                    }
                                </Row>
                             )
                        }
                        {
                            handleDocumentSelect === 'add' && addType !== 1 && (
                                <Row>
                                        <Col className="gutter-row" span={24}>
                                            <ConfigProvider
                                                    theme={{
                                                    token: {
                                                        borderRadiusSM: 50,
                                                        colorPrimary: '#325CEB',
                                                        colorText: '#666666',
                                                        fontSize: 16,
                                                        controlInteractiveSize: 22
                                                    }
                                                    }}
                                            >
                                                <Form.Item
                                                    name="HideForBorrower"
                                                    valuePropName="checked"
                                                    style={{
                                                        marginBottom: 0
                                                    }}
                                                >
                                                    <Checkbox onChange={hideForBoChange}>
                                                        <div className='checkbox-title'>Hide this document request from the borrowers.</div>
                                                    </Checkbox>
                                                </Form.Item>
                                            </ConfigProvider>
                                            <div className='checkbox-subtitle'>The document will be listed as pending upload internally and borrowers will not be notified about this request. </div>
                                        </Col>
                                </Row>
                            )
                        }
                        {
                            handleDocumentSelect === 'upload' && (
                                <Row>
                                    <Col className="gutter-row" span={24} md={24}>
                                        <Form.Item
                                            name="selectFile"
                                            valuePropName="fileList"
                                            getValueFromEvent={e => e.fileList}
                                        >
                                            <Dragger {...draggerProps}>
                                                <p className="ant-upload-drag-icon">
                                                <InboxOutlined />
                                                </p>
                                                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                            </Dragger>
                                        </Form.Item>
                                    </Col>
                                    <div className='file-list'>
                                        {
                                            fileList.map((item, index) => (
                                                <div key={item.uid} className='upload-doc-item'><div><img className='pdf-icon' src={`/images/${item.type === 'application/pdf' ? 'pdf-red' : 'img'}-icon.svg`}/><span>{removeFileExtension(item.name)}</span></div><img src='/images/document-file-remove.svg' onClick={() => handleDeleteDoc(index)} className='delete-doc' /></div>
                                            ))
                                        }
                                    </div>
                                </Row>
                            )
                        }
                                
                            <div className="task-documents">
                                {
                                    handleDocumentSelect === 'add' && addType === 1 && editMode !== 'add' && (
                                        <>
                                            <div className="table-wrap">
                                                <Table
                                                    className="document-table document-request"
                                                    columns={taskDocumentsColumns}
                                                    dataSource={taskDocuments}
                                                    locale={{
                                                        emptyText: (
                                                            <div className="document-request-empty">
                                                                No documents yet. Pick a template above, or add rows one at a time.
                                                            </div>
                                                        ),
                                                    }}
                                                    pagination={false}
                                                    ref={tableRef}
                                                    scroll={{ y: 288 }}
                                                />
                                            </div>
                                            <Button className='add-more-btn' type='link' disabled={editingRow !== -1} onClick={addRequest}>Add more</Button>
                                        </>
                                    )
                                }
                            </div>
                        </div>
                    </Form>
                </Spin>
            </div>
        )
    }

    const uploadDocuments = () => {
        let token = sessionStorage.getItem("ZeitroA")    
        const formData = new FormData()
        fileList.forEach(item => {
            formData.append(`upload`, item.originFileObj)
        })
        let api = ''
        let header = null
        
        // Get description and sanitize it by replacing newlines with period + space
        const description = form.getFieldValue('description')?.replace(/[\r\n]+/g, '. ').trim() || ''
        
        if (editMode === 'upload') {
            api='/los/uploaddocumentsforrequest'
            header = {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "X-TASKID": currentID,
                "X-LOAN": props.loanid
            }
        } else {
            api='/los/uploaddocuments'
            header = {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "X-NAME": form.getFieldValue('name'),
                "X-CATEGORY": form.getFieldValue('category'),
                "X-DESCRIPTION": description,
                "X-LOAN": props.loanid
            }
        }
        setSaveLoading(true)
        fetch(api, {
            cache: 'no-cache',
            method: 'POST',
            body: formData,
            headers: header,
        }).then(response => {
            setSaveLoading(false)
            if (response.status !== 200) {
                message.error('Something went wrong, please try later')
                return;
            }            
            taskCancel()
            getdocuments()
            track(STATSIG.LOAN.DOCUMENT_UPLOAD)

        }).catch(error => {
            setSaveLoading(false)
            console.log(error)
            message.error('Something went wrong, please try later')
        })
    }
    const requestresubmit = () => {
        let token = sessionStorage.getItem("ZeitroA")
        let data = {
            LoanID: props.loanid,
            Task: {
                ID: currentID,
                Deadline: dayjs(form.getFieldValue('deadline')).format('MM/DD/YYYY'),
                Description: form.getFieldValue('description'),
                Files: form.getFieldValue('Files')
            }
        }
        setSaveLoading(true)
        fetch('/los/requestresubmit', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
    
        }).then(
            response => {
                setSaveLoading(false)
                if (response.status !== 200) {
                    message.error('Something went wrong, please try later')
                    return;
                }
                if (response.status === 200 ) {
                    setShowPreviewModal(false)
                    setShowVerifyModal(false)
                    message.success('Resubmission has been requested.')
                    taskCancel()
                    getdocuments()
                }
            }
    
        ).catch((err) => {
            setSaveLoading(false)
            message.error('Something went wrong, please try later')
        })
    }
    const addDocRequest = () => {
        let token = sessionStorage.getItem("ZeitroA")
        let data = {
            LoanID: props.loanid,
            Tasks: []
        }
        if (addType === 1 && appliedDocumentTemplate?.id) {
            data.TemplateID = appliedDocumentTemplate.id
        }
        if (addType === 1) {
            data.Tasks = taskDocuments.map(doc => ({ TaskName: doc.name, TaskID: doc.category, Deadline: dayjs(form.getFieldValue('deadline')).format('MM/DD/YYYY'), ForWhom: form.getFieldValue('recipient'), Description: doc.description, TimeRange: doc.timeRange, HideForBorrower: false}))
        } else { 
            data.Tasks = [
                {
                    TaskName: form.getFieldValue('name'),
                    TaskID: form.getFieldValue('category'),
                    Deadline: dayjs(form.getFieldValue('deadline')).format('MM/DD/YYYY'),
                    ForWhom: form.getFieldValue('recipient'),
                    Description: form.getFieldValue('description'),
                    TimeRange: '',
                    HideForBorrower: form.getFieldValue('HideForBorrower')
                }
            ]
        }
        setSaveLoading(true)
        fetch('/los/adddocumentrequests', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
    
        }).then(
            response => {
                setSaveLoading(false)
                if (response.status !== 200) {
                    message.error('Something went wrong, please try later')
                    return;
                }
                if (response.status === 200 ) {
                    track(STATSIG.LOAN.DOCUMENT_REQUEST, {
                        type: addType === 1 ? 'checklist' : 'single',
                    })
                    logDocumentTemplateEvent(client, 'documents_requested', {
                        template: appliedDocumentTemplate,
                        source: 'document_request',
                        value: data.Tasks.length,
                        metadata: {
                            request_type:
                                addType === 1 ? 'checklist' : 'single',
                            used_template: Boolean(appliedDocumentTemplate?.id),
                            requested_item_count: data.Tasks.length,
                        },
                    })
                    taskCancel()
                    getdocuments()
                    if (reminderSettings.TurnedOn) {
                        setReminderModelType('sent')
                        setHandleReminderOpen(true)
                    }
                }
            }
    
        ).catch((err) => {
            setSaveLoading(false)
            message.error('Something went wrong, please try later')
        })
    }
    const updateDocRequest = () => {
        let token = sessionStorage.getItem("ZeitroA")
        let data = {
            LoanID: props.loanid,
            Task: {
                ID: currentID,
                TaskName: form.getFieldValue('name'),
                TaskID: form.getFieldValue('category'),
                Deadline: dayjs(form.getFieldValue('deadline')).format('MM/DD/YYYY'),
                ForWhom: form.getFieldValue('recipient'),
                Description: form.getFieldValue('description'),
                TimeRange: form.getFieldValue('timerange'),
                HideForBorrower: form.getFieldValue('HideForBorrower')
            }
        }
        setSaveLoading(true)
        fetch('/los/editrequest', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
    
        }).then(
            response => {
                setSaveLoading(false)
                if (response.status !== 200) {
                    message.error('Something went wrong, please try later')
                    return;
                }
                if (response.status === 200 ) {
                    taskCancel()
                    getdocuments()
                }
            }
    
        ).catch((err) => {
            setSaveLoading(false)
            message.error('Something went wrong, please try later')
        })
    }
    const documentSave = () => {
        const currentStatus = props.application.currentStatus;
        if (
            com.CurrentStatus.hasOwnProperty(currentStatus) &&
            com.CurrentStatus[currentStatus] < com.CurrentStatus["ConditionsRequested"]
        ) {
            props.updateApplicationAttribute('Processing', 'currentStage');
            props.updateApplicationAttribute('ConditionsRequested', 'currentStatus');
        }
        validateForm()
        // statsig log
        const fileListAmount = fileList.length;
        const fileListName = fileList.map((item) => item.name);
        void client?.logEvent("documents_uploaded_by_loanofficer", fileListAmount, {
            eventName: "documentsUploadedByBorrower",
            startTime: new Date,
            timestamp: Date.now(),
            fileListAmount: fileListAmount,
            fileListName: fileListName,
            entrance: "applicationDocuments",
            pageUrl: window.location.href,
            documentName: form.getFieldValue('name'),
            documentCategory: form.getFieldValue('category'),
            documentDescription: form.getFieldValue('description'),
            documentDeadline: form.getFieldValue('deadline'),
            documentRecipient: form.getFieldValue('recipient'),
            documentHideForBorrower: form.getFieldValue('HideForBorrower'),
            documentTimeRange: form.getFieldValue('timerange'),
        });
    }
    const taskCancel = () => {
        setShowDocumentModal(false)
        setHandleDocumentSelect('')
        setEditingRow(-1)
        setFileList([])
        setAddType(1)
        setEditMode('')
        setTaskDocuments([])
        setDocumentTemplates([])
        setDocumentTemplatesLoading(false)
        setDocumentTemplatesError('')
        setDocumentTemplateRecommendationState('')
        setAppliedDocumentTemplate(null)
        setAppliedDocumentTemplateItems([])
        setApplyingDocumentTemplateID('')
        setShowSaveDocumentTemplateModal(false)
        setFieldErrors({
            name: false,
            category: false,
        })
        form.resetFields()
    }
    const base64ToArrayBuffer = (base64) => {
        const binaryString = atob(base64)
        const len = binaryString.length
        const bytes = new Uint8Array(len)
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i)
        }
        return bytes.buffer
    }
    const getDocCount = () => {
        const totalUniqueDocumentsLength = originalDocumentList.reduce((uniqueFileNames, item) => {
            if (item.list && Array.isArray(item.list)) {
                item.list.forEach(subItem => {
                    if (subItem.Documents && Array.isArray(subItem.Documents)) {
                        subItem.Documents.forEach(doc => {
                            if (doc.FileName) {
                                uniqueFileNames.add(doc.FileName);
                            }
                        });
                    }
                });
            }
            return uniqueFileNames;
        }, new Set()).size;
        return totalUniqueDocumentsLength
    }
    const downloadAll = (id, type, name, docID, isVerify, isReview) => {
        if (originalDocumentList.every(item => item.list.length === 0)) {
            return
        }
        const requestKey = `${props.application.borrower.firstname} ${props.application.borrower.lastname}`
        const controller = new AbortController()
        const signal = controller.signal
        if (type === 'all' && getDocCount() > 1) {
            setControllers(prevState => ({
                ...prevState,
                [requestKey]: controller,
            }))
            setDownloadData(prevDownloadData => {
                const exists = prevDownloadData.some(item => item.key === requestKey);
                if (exists) {
                    return prevDownloadData.map(item =>
                        item.key === requestKey
                            ? { ...item, status: 'downloading' }
                            : item
                    );
                } else {
                    return [
                        ...prevDownloadData,
                        {
                            key: requestKey,
                            filename: `${props.application.borrower.firstname} ${props.application.borrower.lastname} documents.zip`,
                            status: 'downloading',
                        },
                    ];
                }
            })
            setShowDownloadModal(true)
        }
        let token = sessionStorage.getItem("ZeitroA")
        setTasksLoading(true)
        fetch('/los/downloaddocuments', {
          method: 'POST',
          body: JSON.stringify({ LoanID: props.loanid, TaskID: type !== 'all' ? id : 0, DocID: docID ? docID : 0}),
          headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache"
          },
          signal: signal,
        }).then(async response => {
          if (response.status !== 200) {
            return
          }
          await response.json().then(js => {
                setTasksLoading(false)
                let files = js.Documents;
                if ( type === 'preview' || type === 'move' || type === 'sort') {
                    let file = base64ToArrayBuffer(files[0].Content)
                    let ParsedData = files[0].ParsedData !== '' ? files[0].ParsedData : files[0].VerifiedData
                    if (isVerify) {
                        if (ParsedData === '') {
                            setGeneralValidity(null)
                            setExtractedData([])
                            setMappingData(null)
                        } else {
                            const formatData = JSON.parse(ParsedData)
                            let extractedData = []
                            if (formatData.hasOwnProperty('DocType')) {
                                setDataType("new")
                                extractedData = formatData.ExtractedData.map((item, index) => ({
                                    page: index + 1,
                                    // An upload can hold several documents; each entry says
                                    // which one it came from and on which pages of the file.
                                    pages: item?.pages || "",
                                    comment: "",
                                    docType: item?.docType || formatData.DocType,
                                    possibleDocType: "",
                                    extractedData: item
                                }))
                            } else {
                                setDataType("old")
                                extractedData = formatData.ExtractedData
                            }
                            setGeneralValidity(formatData.GeneralValidity)
                            if (formatData.GeneralValidity && formatData.GeneralValidity.processResult.status === 'success') {
                                setExtractedData(extractedData)
                                setMappingData(formatData.Mapping1003)
                            }
                        }
                        if (isReview) {
                            const filesVerifyData = files.map(item => {
                                const dataToParse = item.VerifiedData !== '' ? item.VerifiedData : (item.ParsedData !== '' ? item.ParsedData : '{}');
                                return {
                                    ...JSON.parse(dataToParse),
                                    id: item.ID,
                                    name: item.Name,
                                }
                            })
                            setFileData(filesVerifyData)
                        }
                        let record = js.OperationRecord.ResubmissionRequest && js.OperationRecord.ResubmissionRequest.length > 0 ? js.OperationRecord.ResubmissionRequest : []
                        setResubmissionRecord(record)
                    } 
                    setFile(file) 
                    setScale(1)
                    setShowPreviewModal(true)
                } else if (files.length === 0) {

                } else if (files.length === 1){
                    let file = base64ToArrayBuffer(files[0].Content)
                    const modifiedPdfBlob = new Blob([file], { type: 'application/pdf' })
                    const downloadLink = document.createElement('a')
                    downloadLink.href = URL.createObjectURL(modifiedPdfBlob)
                    downloadLink.download = files[0].Name
                    downloadLink.click()
                } else {
                    let filename = ''
                    if (type === 'single') {
                        filename =  `${name}.zip`
                    } else {
                        filename =  `${props.application.borrower.firstname} ${props.application.borrower.lastname} documents.zip`
                    }
                    let zip = new JSZip()
                    let filesFolder = zip.folder(`Documents`)
                    for (let i = 0; i < files.length; i++){
                    let {Name, Content} = files[i];
                    filesFolder.file(Name, Content, {base64: true})
                    }
                    zip.generateAsync({type:"blob"}).then(blob=> {
                        saveAs(blob, filename)
                        setDownloadData((prevDataSource) => {
                            const updatedDataSource = prevDataSource.map(item =>
                                item.key === requestKey ? { ...item, status: 'success' } : item
                            );
                            return updatedDataSource;
                        })
                    })
                }
          })
        }).catch((err) => {
            setDownloadData((prevDataSource) => {
                const updatedDataSource = prevDataSource.map(item =>
                    item.key === requestKey ? 
                        { ...item, status: err.name === 'AbortError' ? 'canceled' : 'fail' } 
                        : item
                )
                return updatedDataSource
            })
            setTasksLoading(false)
        })
    }
    const onDocumentLoadSuccess = ({ numPages }) => {
        setPageNumber(1)
        setNumPages(numPages)
    }
    const handleZoom = (val) => {
        setScale(val)
    }
    const onChangePage = (page, pageSize) => {
        setPageNumber(page)
    }
    const previewCancel = () => {
        setPageNumber(1)
        setNumPages(1)
        setHandleForm('')
        setShowPreviewModal(false)
    }
    const changeFile = (toNum, num, editData, filename) => {
        if (fileData[num - 1] && fileData[num - 1].name === filename) {
            const updatedFileData = replaceFiledataExtracted(num, editData)
        }
        let data = task
        let record = data.Documents[toNum - 1]
        setHandleRecord({...record, taskName: data.TaskName, num: toNum, documents: data.Documents, total: data.Documents.length, description: data.Description, duedate: data.Deadline, timeRange: getLabelByValue(timeRangeOptions, data.TimeRange), docType: data.TaskID})
        downloadAll(data.ID, 'preview', record.FileName, record.ID, true)
    }
    const manualChangeFile = (toNum) => {
        let data = task
        let record = data.Documents[toNum - 1]
        setHandleRecord({...record, taskName: data.TaskName, num: toNum, documents: data.Documents, total: data.Documents.length, description: data.Description, duedate: data.Deadline, timeRange: getLabelByValue(timeRangeOptions, data.TimeRange), docType: data.TaskID})
        downloadAll(data.ID, 'preview', record.FileName, record.ID, true)
    }
    const replaceFiledataExtracted = (num, data) => {
        let updatedFileData
        setFileData((prevFileData) => {
            const newFileData = [...prevFileData]
            newFileData[num - 1] = {
                ...newFileData[num - 1],
                ExtractedData: data.length > 0 ? data : []
            }
            updatedFileData = newFileData
            return newFileData
        })
        return updatedFileData
    }
    const handleDocument = (type) => {
        setHandleForm('')
        if (type === 'resubmission') {
            setHandleDocumentList(task.Documents)
            setHandleDocumentSelect('resubmission')
            setEditMode('resubmission')
            form.setFieldsValue({
                name: task.TaskName,
                category: task.TaskID,
            })
            setShowDocumentModal(true)
        } else if (type === 'delete') {
            setCurrentID(handleRecord.ID)
            setCurrentName(handleRecord.FileName)
            setModalType('deleteFile')
            setHandleForm('verify')
            setHandleDocumentOpen(true)
        } else if (type === 'upload') {
            setHandleDocumentSelect('upload')
            setEditMode('upload')
            setHandleForm('verify')
            form.setFieldsValue({
                name: task.TaskName,
                category: task.TaskID,
                description: task.Description
            })
            setShowDocumentModal(true)
        } else {
            downloadAll(task.ID, 'single', task.TaskName)
        }
    }
    const showSaveAsTemplate =
        handleDocumentSelect === 'add' &&
        addType === 1 &&
        editMode !== 'add' &&
        editingRow === -1 &&
        taskDocuments.length > 0
    const isDocumentChecklistRequest =
        handleDocumentSelect === 'add' &&
        addType === 1 &&
        editMode !== 'add'
    const primaryFooterButton = handleDocumentSelect === 'add'
        ? <Button className="task-btn-save" type="primary" disabled={documentTemplatesLoading || (addType === 1 && (taskDocuments.length === 0 || editingRow !== -1 || loading) && editMode !== 'add')} loading={saveLoading} onClick={documentSave}>{editMode === 'add' ? 'Update' : 'Send'} request</Button>
        : handleDocumentSelect === 'upload'
        ? <Button className="task-btn-save" type="primary" disabled={form.getFieldValue('selectFile') === undefined || (form.getFieldValue('selectFile') && form.getFieldValue('selectFile').length === 0)} loading={saveLoading} onClick={documentSave}>Upload</Button>
        : <Button className="task-btn-save" type="primary" loading={saveLoading} onClick={documentSave}>Send request</Button>
    const footer = (
        <>
            <div className="document-request-footer-secondary">
                {isDocumentChecklistRequest &&
                (documentRequestHasContent(taskDocuments) ||
                    appliedDocumentTemplate) ? (
                    <Button
                        className="task-btn-cancel"
                        disabled={loading || documentTemplatesLoading}
                        onClick={clearDocumentRequestChecklist}
                        type="link"
                    >
                        Clear list
                    </Button>
                ) : !isDocumentChecklistRequest ? (
                    <Button className="task-btn-cancel" type="link" onClick={taskCancel}>Cancel</Button>
                ) : null}
                {showSaveAsTemplate && (
                    <Button
                        className="document-template-save-trigger"
                        disabled={documentTemplatesLoading}
                        icon={<SaveOutlined />}
                        onClick={() => setShowSaveDocumentTemplateModal(true)}
                    >
                        Save as template
                    </Button>
                )}
            </div>
            <div className="document-request-footer-primary">
                {isDocumentChecklistRequest && (
                    <Tooltip title="Automatically generate the required documents">
                        <Button
                            className="task-btn-auto-generate"
                            disabled={
                                (editingRow !== -1 &&
                                    documentRequestHasContent(taskDocuments)) ||
                                documentTemplatesLoading ||
                                saveLoading
                            }
                            icon={!loading ? <FileTextOutlined /> : null}
                            loading={loading}
                            onClick={autoGenerateDocumentChecklist}
                        >
                            Auto-generate
                        </Button>
                    </Tooltip>
                )}
                {primaryFooterButton}
            </div>
        </>
    )
    const verifyCancel = () => {
        setShowVerifyModal(false)
    }
    const ReminderCancel = () => {
        setShowAutoReminderModal(false)
        getLoanAutoReminderConfiguration()
    }
    const ReminderSave = (data) => {
        let autoReminderData = {
            ...data,
            EndWhen: {
                ...data.EndWhen,
                WhenDate: data.EndWhen.WhenLoanFunded === true ? null : data.EndWhen.WhenDate,
                AfterNumberOfDays: null
            }
        }
        setLoanAutoReminderConfiguration(autoReminderData, 'settings')
    }
    const moveFile = (taskID) => {
        let token = sessionStorage.getItem("ZeitroA")
        let data = {
            TaskID: taskID,
            DocID: handleRecord.ID
        }
        fetch('/los/movedoc', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
    
        }).then(
            response => {
                if (response.status !== 200) {
                    message.error('Something went wrong, please try later')
                    return;
                }
                if (response.status === 200 ) {
                    setShowPreviewModal(false)
                    getdocuments()
                }
            }
    
        ).catch((err) => {
            
            message.error('Something went wrong, please try later')
        })
    }
    const manualVerify = (num, editData, filename) => {
        //record the time of start verify
        startVerifyTime.current = Date.now()
        setExtractedData(editData)
        if (fileData[num - 1] && fileData[num - 1].name === filename) {
            replaceFiledataExtracted(num, editData)
        }
        setShowVerifyMode('manual')
        setShowVerifyModal(true)
    }
    const manualComplete = () => {
        fileData.forEach(item => {
            let obj = {
                Mapping1003: item.Mapping1003 ? item.Mapping1003 : null,
                ExtractedData: item.ExtractedData ? dataType === "new" ? item.ExtractedData.map(item => item.extractedData) : item.ExtractedData : [],
                GeneralValidity: item.GeneralValidity ? item.GeneralValidity : null,
            }
            if (dataType === "new") {
                if (item.ExtractedData && item.ExtractedData.length > 0) {
                    obj.DocType = item.ExtractedData[0].docType;
                } else {
                    obj.DocType = "";
                }
            }
            verifydocument(obj, item.id)
        })
    }
    const verifyDoc = (num, editData, filename) => {
        setExtractedData(editData)
        if (fileData[num - 1] && fileData[num - 1].name === filename) {
            replaceFiledataExtracted(num, editData)
        }
        setShowVerifyMode('smart')
        setShowVerifyModal(true)
    }
    const verifydocument = (data, id) => {
        let token = sessionStorage.getItem("ZeitroA")
        fetch('/los/verifydocument/' + id, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
    
        }).then(
            response => {
                if (response.status !== 200) {
                    message.error('Something went wrong, please try later')
                    return;
                }
                if (response.status === 200 ) {
                    setShowVerifyModal(false)
                    setShowPreviewModal(false)
                }
            }
    
        ).catch((err) => {
            
            message.error('Something went wrong, please try later')
        })
    }
    const completeVerify = (num, editData, filename) => {
        if (fileData[num - 1] && fileData[num - 1].name === filename) {
            const updatedFileData = replaceFiledataExtracted(num, editData)
            updatedFileData.forEach(item => {
                let obj = {
                    Mapping1003: item.Mapping1003,
                    ExtractedData: dataType === "new" ? item.ExtractedData.map(item => item.extractedData) : item.ExtractedData,
                    GeneralValidity: item.GeneralValidity,
                }
                if (dataType === "new") {
                    // The file's own type, not the first reading's: an upload can
                    // hold several documents, and its first one is not what the
                    // file is. Saving that would refile a tax package as
                    // whichever form happened to start it.
                    obj.DocType = item.DocType || ""
                }
                verifydocument(obj, item.id)
            })
        }
    }
    const complete = async (data, data2, updatedKeys, smartCtx) => {
        const cleanCurrencyValue = (value) => {
            if (typeof value === 'string') {
                if (!value.includes('$') && !/\d,\d{3}/.test(value)) {
                    return value;
                }
                const cleaned = value.replace(/[$,]/g, '');
                const num = Number(cleaned);
                if (isNaN(num) || cleaned.trim() === '') {
                    return value;
                }
                return Math.round(num);
            }
            if (typeof value === 'number') {
                return Math.round(value);
            }
            return value;
        };

        // A value the reviewer accepted. false and 0 are values -- the
        // self-employed flag a business return offers is a boolean, and a
        // plain truthiness test dropped "No" on the floor. An empty string is
        // still skipped: "update all" marks every row the document differs on,
        // including the ones it says nothing about, and those must not blank
        // out what the borrower typed.
        const hasValue = (v) => v !== undefined && v !== null && v !== ''

        const updates = []
        Object.keys(updatedKeys || {}).forEach(key => {
            if (updatedKeys[key]) {
                // Which column the reviewer accepted this row into. `true` is
                // the older shape, from before each borrower had their own
                // Update button, and meant both.
                const columns = updatedKeys[key]
                const wantPrimary = columns === true || !!columns.primary
                const wantSecondary = columns === true || !!columns.secondary
                const keyParts = key.split('.')
                const index = parseInt(keyParts[0], 10)
                const pathArray = keyParts.slice(1)
    
                let currentData1 = fileData[index]?.Mapping1003
                let currentData2 = data?.[index]
                let currentData3 = data2?.[index]
    
                let tempData1 = currentData1
                let tempData2 = currentData2
                let tempData3 = currentData3
    
                for (let i = 0; i < pathArray.length; i++) {
                    const subKey = pathArray[i];
    
                    if (tempData1) {
                        tempData1 = tempData1[subKey]
                    }
    
                    if (tempData2) {
                        tempData2 = tempData2[subKey]
                    }
    
                    if (tempData3) {
                        tempData3 = tempData3[subKey]
                    }

                    if (!tempData1 || (!tempData2 && !tempData3)) {
                        break
                    }
                }
    
                if (wantPrimary && tempData1 && hasValue(tempData2)) {
                    const statePath = tempData1.StatePath
                    let value = tempData1.ValueType && tempData1.ValueType === 'intstring'
                        ? parseInt(tempData2, 10)
                        : tempData2
                    
                    value = cleanCurrencyValue(value);
                    if (statePath) updates.push({ path: statePath, value })
                }
    
                if (wantSecondary && tempData1 && hasValue(tempData3)) {
                    const statePath = tempData1.StatePath.replace(/\bborrower\b/g, 'coborrower')
                    let value = tempData1.ValueType && tempData1.ValueType === 'intstring'
                        ? parseInt(tempData3, 10)
                        : tempData3
                    
                    value = cleanCurrencyValue(value);
                    if (statePath) updates.push({ path: statePath, value })
                }
                if (tempData1?.StateChanges && Array.isArray(tempData1.StateChanges)) {
                    tempData1.StateChanges.forEach(change => {
                        const cleanedValue = cleanCurrencyValue(change.value)
                        if (wantPrimary && hasValue(tempData2) && change.path) {
                            updates.push({ path: change.path, value: cleanedValue })
                        }
                        if (wantSecondary && hasValue(tempData3) && change.path) {
                            const coPath = change.path.replace(/\bborrower\b/g, 'coborrower')
                            if (coPath) updates.push({ path: coPath, value: cleanedValue })
                        }
                    })
                }
            }
        })
        try {
            await applySmartVerifyUpdates(props.loanid, smartCtx, updates)
        } catch (err) {
            message.error(err.message || "Failed to save Smart Verify updates")
            return
        }
        fileData.forEach(item => {
            let obj = {
                Mapping1003: item.Mapping1003 ? item.Mapping1003 : null,
                ExtractedData: item.ExtractedData ? dataType === "new" ? item.ExtractedData.map(item => item.extractedData) : item.ExtractedData : [],
                GeneralValidity: item.GeneralValidity ? item.GeneralValidity : null,
            }
            if (dataType === "new") {
                if (item.ExtractedData && item.ExtractedData.length > 0) {
                    obj.DocType = item.ExtractedData[0].docType
                } else {
                    obj.DocType = ""
                }
            }
            verifydocument(obj, item.id)
        })
    }
    const changeWhenLoanFunded = (v) => {
        setWhenLoanFunded(v)
    }
    const handleCancelDownload = useCallback((key) => {
        setDownloadData((prevDataSource) => {
            const updatedDataSource = prevDataSource.map(item =>
                item.key === key ? { ...item, status: 'canceled' } : item
            )
            return updatedDataSource
        })

        setControllers((prevControllers) => {
            const controller = prevControllers[key]
            if (controller) {
                controller.abort()
            }
            const updatedControllers = { ...prevControllers }
            delete updatedControllers[key]
            return updatedControllers
        })
    }, [])

    const handleRetryDownload = useCallback((key) => {
        const record = downloadData.find(item => item.key === key)
        if (record) {
            downloadAll(null, 'all')
        }
    }, [downloadData])

    const handleCancelAll = useCallback(() => {
        Object.values(controllers).forEach(controller => {
            controller.abort()
        })

        setDownloadData((prevDataSource) =>
            prevDataSource.map(item =>
                item.status === 'downloading' ? { ...item, status: 'canceled' } : item
            )
        )
        setControllers({})
    }, [controllers])
    const formatStatusText = (status, key) => {
        switch (status) {
            case 'success':
              return 'Successful'
            case 'fail':
              return <span>Failed. Please <span style={{ color: '#325CEB', fontWeight: 500, cursor: 'pointer', textDecorationLine: 'underline' }} onClick={() => handleRetryDownload(key)}>retry</span></span>
            case 'canceled':
              return 'Canceled';
            default:
              return 'Downloading';
        }
    }
    const formatStatusIcon = (status) => {
        switch (status) {
            case 'success':
              return <img src='/images/download-success.svg' />
            case 'fail':
              return <img src='/images/download-fail.svg' />
            case 'downloading':
              return (
                <AutoProgress 
                    type="circle"
                    showInfo={false}
                    percent="auto"
                    strokeWidth={10}
                    trailColor="#BDCBFB" 
                    strokeColor="#325CEB"
                    size={26}
                />
              )
            default:
              return '';
        }
    }
    const downloadColumns = [
        {
          title: 'File name',
          dataIndex: 'filename',
          key: 'filename',
          width: '55%',
          render: (text, record) => (
            <div style={{ fontWeight: 500, display: 'flex', alignItems: 'center', gap: 4 }}>
                <div style={{
                    lineHeight: '20px',
                    whiteSpace: 'normal',
                    wordBreak: 'break-all',
                }}>{text}</div>
                {record.status !== 'canceled' && record.status !== 'success' && (
                    <CloseCircleOutlined
                        style={{ color: '#6E6E70', cursor: 'pointer' }}
                        onClick={() => handleCancelDownload(record.key)}
                    />
                )}
            </div>
          )
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          render: (text, record) => (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {record.status !== 'canceled' && <div className="download-status-icon">{formatStatusIcon(text)}</div>}
                <div className="download-status-text">{formatStatusText(text, record.key)}</div>
            </div>
          )
        }
    ]
    const noDownloading = downloadData.every(item => item.status !== 'downloading')
    const downloadFooter = noDownloading
        ? [
            <Button
                className='download-status-btn status-close'
                type='primary'
                onClick={() => {
                    setShowDownloadModal(false)
                    setDownloadData([])
                }}>
                Close
            </Button>
        ] : [
            <Button
                className='download-status-btn status-cancel'
                type='border'
                onClick={() => handleCancelAll()}
            >
                Cancel all
            </Button>
        ]
    return (
        <div>
            {contextHolder}
            {showCurrentTasks()}
            <Modal
                className="create-task-modal full-modal"
                width={976}
                centered={true}
                destroyOnClose
                open={showDocumentModal}
                title=""
                onCancel={taskCancel}
                footer={footer}
            >
                {showCreateNewTasks()}

            </Modal>
            <SaveDocumentTemplateModal
                appliedTemplate={appliedDocumentTemplate}
                context={documentTemplateLoanContext}
                edited={appliedDocumentTemplateEdited}
                items={taskDocuments}
                onCancel={() => setShowSaveDocumentTemplateModal(false)}
                onSaved={handleDocumentTemplateSaved}
                open={showSaveDocumentTemplateModal}
            />
            <PreviewModal
                mode={previewMode}
                open={showPreviewModal}
                data={handleRecord}
                docmentList={documentList}
                file={file}
                files={fileData}
                pageNumber={pageNumber}
                numPages={numPages}
                width={pageWidth}
                scale={scale}
                extractedData={extractedData}
                generalValidity={generalValidity}
                mappingData={mappingData}
                resubmissionRecord={resubmissionRecord}
                moveFile={moveFile}
                manualVerify={manualVerify}
                verify={verifyDoc}
                complete={completeVerify}
                change={changeFile}
                onCancel={previewCancel}
                handleDocument={handleDocument}
                handleZoom={(val) => handleZoom(val)}
                handlePage={(page, pageSize) => onChangePage(page, pageSize)}
                loadSuccess={(page) => onDocumentLoadSuccess(page)}
            >

            </PreviewModal>
            <VerifyModal
                mode={showVerifyMode}
                data={handleRecord}
                file={file}
                files={fileData}
                pageNumber={pageNumber}
                numPages={numPages}
                scale={scale}
                open={showVerifyModal}
                loanid={props.loanid}
                documentSubjects={documentSubjects}
                extractedData={extractedData}
                mappingData={mappingData}
                onCancel={verifyCancel}
                complete={complete}
                change={manualChangeFile}
                manualVerify={manualComplete}
                handleDocument={handleDocument}
                handleZoom={(val) => handleZoom(val)}
                handlePage={(page, pageSize) => onChangePage(page, pageSize)}
                loadSuccess={(page) => onDocumentLoadSuccess(page)}
                startVerifyTime={startVerifyTime}
            >
            </VerifyModal>
            <Modal
                className='borrower-download-status-modal'
                styles={{ mask: { backgroundColor: 'rgba(0, 0, 0, 0.75)' } }}
                // destroyOnClose
                maskClosable={false}
                width={566}
                closable={false}
                open={showDownloadModal}
                centered={true}
                title=""
                onCancel={() => {
                    setShowDownloadModal(false)
                    setDownloadData([])
                }}
                footer={downloadFooter}
            >
                <div className='download-status-modal-title'>Download</div>
                <div className='download-status-modal-content'>
                    <div className="download-status-modal-tips">Downloading files may take up to 1 minute. Please keep this tab open.</div>
                    <div>
                        <Table
                            className="download-status-table"
                            pagination={false}
                            columns={downloadColumns}
                            dataSource={downloadData}
                        />
                    </div>
                </div>
            </Modal>
            <AutoReminderModal
                open={showAutoReminderModal}
                settings={reminderSettings}
                lastReminder={lastReminder}
                changeWhenLoanFunded={changeWhenLoanFunded}
                save={ReminderSave}
                onCancel={ReminderCancel}
            >
            </AutoReminderModal>             
        </div>
    )
}
Tasks = connect(mapStateToProps, mapDispatchToProps)(Tasks);
